import React, { useState, useEffect } from 'react';
import logo from './logo.png';
import './App.css';
import { auth, db } from './firebase';
import { signInWithPopup, GoogleAuthProvider, signOut, onAuthStateChanged } from "firebase/auth";
import { doc, setDoc, addDoc, getDoc, getDocs, deleteDoc, collection, query, orderBy, serverTimestamp } from "firebase/firestore";
import html2canvas from 'html2canvas';
import { Analytics } from '@vercel/analytics/react';

const allTeams = [
  'Abilene Christian', 'Air Force', 'Akron', 'Alabama', 'Alabama A&M', 'Alabama State', 'Albany', 'Alcorn State',
  'American', 'Appalachian State', 'Arizona', 'Arizona State', 'Arkansas', 'Arkansas State', 'Arkansas-Pine Bluff',
  'Army', 'Auburn', 'Austin Peay', 'Ball State', 'Baylor', 'Bellarmine', 'Belmont', 'Bethune-Cookman', 'Binghamton',
  'Boise State', 'Boston College', 'Boston University', 'Bowling Green', 'Bradley', 'Brown', 'Bryant', 'Bucknell',
  'Buffalo', 'Butler', 'BYU','Cal Poly', 'Cal State Bakersfield', 'Cal State Fullerton', 'Cal State Northridge', 'California',
  'California Baptist', 'Campbell', 'Canisius', 'Central Arkansas', 'Central Connecticut State', 'Central Michigan',
  'Charleston Southern', 'Charlotte', 'Chattanooga', 'Chicago State', 'Cincinnati', 'Citadel', 'Clemson', 'Cleveland State',
  'Coastal Carolina', 'Colgate', 'College of Charleston', 'Colorado', 'Colorado State', 'Columbia', 'Connecticut',
  'Coppin State', 'Cornell', 'Creighton', 'Dartmouth', 'Davidson', 'Dayton', 'Delaware', 'Delaware State', 'Denver',
  'DePaul', 'Detroit Mercy', 'Drake', 'Drexel', 'Duke', 'Duquesne', 'East Carolina', 'East Tennessee State',
  'Eastern Illinois', 'Eastern Kentucky', 'Eastern Michigan', 'Eastern Washington', 'Elon', 'Evansville', 'Fairfield',
  'Fairleigh Dickinson', 'Florida', 'Florida A&M', 'Florida Atlantic', 'Florida Gulf Coast', 'Florida International',
  'Florida State', 'Fordham', 'Fresno State', 'Furman', 'Gardner-Webb', 'George Mason', 'George Washington', 'Georgetown',
  'Georgia', 'Georgia Southern', 'Georgia State', 'Georgia Tech', 'Gonzaga', 'Grambling State', 'Grand Canyon', 'Green Bay',
  'Hampton', 'Harvard', 'Hawaii', 'High Point', 'Hofstra', 'Holy Cross', 'Houston', 'Houston Christian', 'Howard',
  'Idaho', 'Idaho State', 'Illinois', 'Illinois State', 'Illinois-Chicago', 'Incarnate Word', 'Indiana', 'Indiana State',
  'Indiana University Indianapolis', 'Iona', 'Iowa', 'Iowa State', 'Jackson State', 'Jacksonville', 'Jacksonville State',
  'James Madison', 'Kansas', 'Kansas City', 'Kansas State', 'Kennesaw State', 'Kent State', 'Kentucky', 'La Salle',
  'Lafayette', 'Lamar', 'Le Moyne', 'Lehigh', 'Liberty', 'Lindenwood', 'Lipscomb', 'Little Rock', 'LIU', 'Long Beach State',
  'Long Island', 'Longwood', 'Louisiana', 'Louisiana Tech', 'Louisiana-Monroe', 'Louisville', 'Loyola Chicago', 'Loyola Marymount',
  'Loyola Maryland', 'LSU', 'Maine', 'Manhattan', 'Marist', 'Marquette', 'Marshall', 'Maryland', 'Maryland Eastern Shore',
  'Massachusetts', 'McNeese State', 'Memphis', 'Mercer', 'Mercyhurst', 'Merrimack', 'Miami (FL)', 'Miami (OH)', 'Michigan',
  'Michigan State', 'Middle Tennessee', 'Milwaukee', 'Minnesota', 'Mississippi State', 'Mississippi Valley State', 'Missouri',
  'Missouri State', 'Monmouth', 'Montana', 'Montana State', 'Morehead State', 'Morgan State', 'Mount St. Mary\'s', 'Murray State',
  'Navy', 'NC State', 'Nebraska', 'Nevada', 'New Hampshire', 'New Haven', 'New Mexico', 'New Mexico State', 'New Orleans',
  'Niagara', 'Nicholls State', 'NJIT', 'Norfolk State', 'North Alabama', 'North Carolina', 'North Carolina A&T', 'North Carolina Central',
  'North Dakota', 'North Dakota State', 'North Florida', 'North Texas', 'Northeastern', 'Northern Arizona', 'Northern Colorado',
  'Northern Illinois', 'Northern Iowa', 'Northern Kentucky', 'Northwestern', 'Northwestern State', 'Notre Dame', 'Oakland',
  'Ohio', 'Ohio State', 'Oklahoma', 'Oklahoma State', 'Old Dominion', 'Omaha', 'Oral Roberts', 'Oregon', 'Oregon State',
  'Pacific', 'Penn State', 'Pennsylvania', 'Pepperdine', 'Pittsburgh', 'Portland', 'Portland State', 'Prairie View A&M',
  'Presbyterian', 'Princeton', 'Providence', 'Purdue', 'Purdue Fort Wayne', 'Queens', 'Quinnipiac', 'Radford', 'Rhode Island',
  'Rice', 'Richmond', 'Rider', 'Robert Morris', 'Rutgers', 'Sacramento State', 'Sacred Heart', 'Saint Francis (PA)', 'Saint Joseph\'s',
  'Saint Louis', 'Saint Mary\'s', 'Saint Peter\'s', 'Sam Houston State', 'Samford', 'San Diego', 'San Diego State', 'San Francisco',
  'San Jose State', 'Santa Clara', 'Seattle', 'Seton Hall', 'Siena', 'SIU Edwardsville', 'South Alabama', 'South Carolina',
  'South Carolina State', 'South Dakota', 'South Dakota State', 'South Florida', 'Southeast Missouri State', 'Southeastern Louisiana',
  'Southern', 'Southern Illinois', 'Southern Indiana', 'Southern Methodist', 'Southern Mississippi', 'Southern Utah', 'St. Bonaventure',
  'St. John\'s', 'St. Thomas', 'Stanford', 'Stephen F. Austin', 'Stetson', 'Stonehill', 'Stony Brook', 'Syracuse', 'Tarleton State',
  'TCU', 'Temple', 'Tennessee', 'Tennessee State', 'Tennessee Tech', 'Texas', 'Texas A&M', 'Texas A&M-Commerce',
  'Texas A&M-Corpus Christi', 'Texas Southern', 'Texas State', 'Texas Tech', 'The Citadel', 'Toledo', 'Towson', 'Troy',
  'Tulane', 'Tulsa', 'UAB', 'UC Davis', 'UC Irvine', 'UC Riverside', 'UC San Diego', 'UC Santa Barbara', 'UCF', 'UCLA',
  'UMBC', 'UMass', 'UMass Lowell', 'UNC Asheville', 'UNC Greensboro', 'UNC Wilmington', 'UNLV', 'USC', 'USC Upstate',
  'UT Arlington', 'UT Martin', 'UT Rio Grande Valley', 'UTSA', 'Utah', 'Utah State', 'Utah Tech', 'Utah Valley',
  'Valparaiso', 'Vanderbilt', 'Vermont', 'Villanova', 'Virginia', 'Virginia Commonwealth', 'Virginia Military Institute',
  'Virginia Tech', 'Wagner', 'Wake Forest', 'Washington', 'Washington State', 'Weber State', 'West Georgia', 'West Virginia',
  'Western Carolina', 'Western Illinois', 'Western Kentucky', 'Western Michigan', 'Wichita State', 'William & Mary',
  'Winthrop', 'Wisconsin', 'Wofford', 'Wright State', 'Wyoming', 'Xavier', 'Yale', 'Youngstown State'
];

// ---- 2026-27 NCAA Tournament format ----
// Field expanded from 68 to 76 teams. The "First Four" is now the "Opening Round"
// and grows from 4 games to 12 games (24 teams): 6 games among the 12 lowest-seeded
// automatic qualifiers, and 6 games among the 12 lowest-seeded at-large teams.
// The Round of 64 itself is unchanged (4 regions x 16 seeds) - Opening Round winners
// simply fill in the seed lines their game was assigned to.
const TOTAL_TEAMS = 76;
const OPENING_ROUND_GAMES = 12;

const defaultOpeningRoundConfig = [
  // Automatic-qualifier games (6) - fixed by NCAA rule, not just a default:
  // 8 total 16-seeds and 6 total 15-seeds each year, confirmed structurally.
  // The 4 seed-16 games are fully locked (seed AND region) - every region
  // has exactly one 16-seed line, so all 4 regions get one of these no
  // matter which game object is labeled which region.
  //
  // The 2 seed-15 games are only SEED-locked. Which two regions actually
  // host them is the committee's own bracketing call, not an NCAA rule -
  // so region stays editable for these (see `seedLocked`).
  { seed: 16, region: 'East', locked: true },
  { seed: 16, region: 'West', locked: true },
  { seed: 16, region: 'South', locked: true },
  { seed: 16, region: 'Midwest', locked: true },
  { seed: 15, region: 'East', seedLocked: true },
  { seed: 15, region: 'West', seedLocked: true },
  // At-large games (6) - both the seed line AND which region hosts them
  // vary year to year based on the committee's S-curve, so these stay
  // fully adjustable. Default spread across 11/12/13 as a starting point.
  { seed: 11, region: 'East' },
  { seed: 11, region: 'West' },
  { seed: 12, region: 'South' },
  { seed: 12, region: 'Midwest' },
  { seed: 13, region: 'South' },
  { seed: 13, region: 'Midwest' },
];

// ---- Conference affiliations for the 'every conference gets at least one
// automatic bid' rule - this mirrors reality: each of the ~31 Division I
// conferences sends its champion to the tournament automatically, so a
// complete bracket should never have zero teams from any conference.
// Compiled from current 2026-27 realignment (verified against Wikipedia's
// men's basketball program list + conference realignment coverage as of
// August 2026) - conference realignment moves fast, so if you know of a
// team that switched conferences after this was compiled, just update its
// entry here directly.
const TEAM_CONFERENCES = {
  'Abilene Christian': 'UAC', 'Air Force': 'Mountain West', 'Akron': 'MAC',
  'Alabama': 'SEC', 'Alabama A&M': 'SWAC', 'Alabama State': 'SWAC',
  'Albany': 'America East', 'Alcorn State': 'SWAC', 'American': 'Patriot League',
  'Appalachian State': 'Sun Belt', 'Arizona': 'Big 12', 'Arizona State': 'Big 12',
  'Arkansas': 'SEC', 'Arkansas State': 'Sun Belt', 'Arkansas-Pine Bluff': 'SWAC',
  'Army': 'Patriot League', 'Auburn': 'SEC', 'Austin Peay': 'UAC',
  'BYU': 'Big 12', 'Ball State': 'MAC', 'Baylor': 'Big 12',
  'Bellarmine': 'ASUN', 'Belmont': 'Missouri Valley', 'Bethune-Cookman': 'SWAC',
  'Binghamton': 'America East', 'Boise State': 'Pac-12', 'Boston College': 'ACC',
  'Boston University': 'Patriot League', 'Bowling Green': 'MAC', 'Bradley': 'Missouri Valley',
  'Brown': 'Ivy League', 'Bryant': 'America East', 'Bucknell': 'Patriot League',
  'Buffalo': 'MAC', 'Butler': 'Big East', 'Cal Poly': 'Big West',
  'Cal State Bakersfield': 'Big West', 'Cal State Fullerton': 'Big West', 'Cal State Northridge': 'Big West',
  'California': 'ACC', 'California Baptist': 'Big West', 'Campbell': 'CAA',
  'Canisius': 'Metro Conference', 'Central Arkansas': 'UAC', 'Central Connecticut State': 'NEC',
  'Central Michigan': 'MAC', 'Charleston Southern': 'Big South', 'Charlotte': 'American',
  'Chattanooga': 'Southern', 'Chicago State': 'NEC', 'Cincinnati': 'Big 12',
  'Citadel': 'Southern', 'Clemson': 'ACC', 'Cleveland State': 'Horizon League',
  'Coastal Carolina': 'Sun Belt', 'Colgate': 'Patriot League', 'College of Charleston': 'CAA',
  'Colorado': 'Big 12', 'Colorado State': 'Pac-12', 'Columbia': 'Ivy League',
  'Connecticut': 'Big East', 'Coppin State': 'MEAC', 'Cornell': 'Ivy League',
  'Creighton': 'Big East', 'Dartmouth': 'Ivy League', 'Davidson': 'Atlantic 10',
  'Dayton': 'Atlantic 10', 'DePaul': 'Big East', 'Delaware': 'Conference USA',
  'Delaware State': 'MEAC', 'Denver': 'West Coast', 'Detroit Mercy': 'Horizon League',
  'Drake': 'Missouri Valley', 'Drexel': 'CAA', 'Duke': 'ACC',
  'Duquesne': 'Atlantic 10', 'East Carolina': 'American', 'East Tennessee State': 'Southern',
  'Eastern Illinois': 'Ohio Valley', 'Eastern Kentucky': 'UAC', 'Eastern Michigan': 'MAC',
  'Eastern Washington': 'Big Sky', 'Elon': 'CAA', 'Evansville': 'Missouri Valley',
  'Fairfield': 'Metro Conference', 'Fairleigh Dickinson': 'NEC', 'Florida': 'SEC',
  'Florida A&M': 'SWAC', 'Florida Atlantic': 'American', 'Florida Gulf Coast': 'ASUN',
  'Florida International': 'Conference USA', 'Florida State': 'ACC', 'Fordham': 'Atlantic 10',
  'Fresno State': 'Pac-12', 'Furman': 'Southern', 'Gardner-Webb': 'Big South',
  'George Mason': 'Atlantic 10', 'George Washington': 'Atlantic 10', 'Georgetown': 'Big East',
  'Georgia': 'SEC', 'Georgia Southern': 'Sun Belt', 'Georgia State': 'Sun Belt',
  'Georgia Tech': 'ACC', 'Gonzaga': 'Pac-12', 'Grambling State': 'SWAC',
  'Grand Canyon': 'Mountain West', 'Green Bay': 'Horizon League', 'Hampton': 'CAA',
  'Harvard': 'Ivy League', 'Hawaii': 'Mountain West', 'High Point': 'Big South',
  'Hofstra': 'CAA', 'Holy Cross': 'Patriot League', 'Houston': 'Big 12',
  'Houston Christian': 'Southland', 'Howard': 'MEAC', 'Idaho': 'Big Sky',
  'Idaho State': 'Big Sky', 'Illinois': 'Big Ten', 'Illinois State': 'Missouri Valley',
  'Illinois-Chicago': 'Horizon League', 'Incarnate Word': 'Southland', 'Indiana': 'Big Ten',
  'Indiana State': 'Missouri Valley', 'Indiana University Indianapolis': 'Horizon League', 'Iona': 'Metro Conference',
  'Iowa': 'Big Ten', 'Iowa State': 'Big 12', 'Jackson State': 'SWAC',
  'Jacksonville': 'ASUN', 'Jacksonville State': 'Conference USA', 'James Madison': 'Sun Belt',
  'Kansas': 'Big 12', 'Kansas City': 'Summit League', 'Kansas State': 'Big 12',
  'Kennesaw State': 'Conference USA', 'Kent State': 'MAC', 'Kentucky': 'SEC',
  'LIU': 'NEC', 'LSU': 'SEC', 'La Salle': 'Atlantic 10',
  'Lafayette': 'Patriot League', 'Lamar': 'Southland', 'Le Moyne': 'NEC',
  'Lehigh': 'Patriot League', 'Liberty': 'Conference USA', 'Lindenwood': 'Ohio Valley',
  'Lipscomb': 'ASUN', 'Little Rock': 'UAC', 'Long Beach State': 'Big West',
  'Long Island': 'NEC', 'Longwood': 'Big South', 'Louisiana': 'Sun Belt',
  'Louisiana Tech': 'Conference USA', 'Louisiana-Monroe': 'Sun Belt', 'Louisville': 'ACC',
  'Loyola Chicago': 'Atlantic 10', 'Loyola Maryland': 'Patriot League', 'Loyola Marymount': 'West Coast',
  'Maine': 'America East', 'Manhattan': 'Metro Conference', 'Marist': 'Metro Conference',
  'Marquette': 'Big East', 'Marshall': 'Sun Belt', 'Maryland': 'Big Ten',
  'Maryland Eastern Shore': 'MEAC', 'Massachusetts': 'MAC', 'McNeese State': 'Southland',
  'Memphis': 'American', 'Mercer': 'Southern', 'Mercyhurst': 'NEC',
  'Merrimack': 'Metro Conference', 'Miami (FL)': 'ACC', 'Miami (OH)': 'MAC',
  'Michigan': 'Big Ten', 'Michigan State': 'Big Ten', 'Middle Tennessee': 'Conference USA',
  'Milwaukee': 'Horizon League', 'Minnesota': 'Big Ten', 'Mississippi State': 'SEC',
  'Mississippi Valley State': 'SWAC', 'Missouri': 'SEC', 'Missouri State': 'Conference USA',
  'Monmouth': 'CAA', 'Montana': 'Big Sky', 'Montana State': 'Big Sky',
  'Morehead State': 'Ohio Valley', 'Morgan State': 'MEAC', 'Mount St. Mary\'s': 'Metro Conference',
  'Murray State': 'Missouri Valley', 'NC State': 'ACC', 'NJIT': 'America East',
  'Navy': 'Patriot League', 'Nebraska': 'Big Ten', 'Nevada': 'Mountain West',
  'New Hampshire': 'America East', 'New Haven': 'NEC', 'New Mexico': 'Mountain West',
  'New Mexico State': 'Conference USA', 'New Orleans': 'Southland', 'Niagara': 'Metro Conference',
  'Nicholls State': 'Southland', 'Norfolk State': 'MEAC', 'North Alabama': 'UAC',
  'North Carolina': 'ACC', 'North Carolina A&T': 'CAA', 'North Carolina Central': 'MEAC',
  'North Dakota': 'Summit League', 'North Dakota State': 'Summit League', 'North Florida': 'ASUN',
  'North Texas': 'American', 'Northeastern': 'CAA', 'Northern Arizona': 'Big Sky',
  'Northern Colorado': 'Big Sky', 'Northern Illinois': 'Horizon League', 'Northern Iowa': 'Missouri Valley',
  'Northern Kentucky': 'Horizon League', 'Northwestern': 'Big Ten', 'Northwestern State': 'Southland',
  'Notre Dame': 'ACC', 'Oakland': 'Horizon League', 'Ohio': 'MAC',
  'Ohio State': 'Big Ten', 'Oklahoma': 'SEC', 'Oklahoma State': 'Big 12',
  'Old Dominion': 'Sun Belt', 'Omaha': 'Summit League', 'Oral Roberts': 'Summit League',
  'Oregon': 'Big Ten', 'Oregon State': 'Pac-12', 'Pacific': 'West Coast',
  'Penn State': 'Big Ten', 'Pennsylvania': 'Ivy League', 'Pepperdine': 'West Coast',
  'Pittsburgh': 'ACC', 'Portland': 'West Coast', 'Portland State': 'Big Sky',
  'Prairie View A&M': 'SWAC', 'Presbyterian': 'Big South', 'Princeton': 'Ivy League',
  'Providence': 'Big East', 'Purdue': 'Big Ten', 'Purdue Fort Wayne': 'Horizon League',
  'Queens': 'ASUN', 'Quinnipiac': 'Metro Conference', 'Radford': 'Big South',
  'Rhode Island': 'Atlantic 10', 'Rice': 'American', 'Richmond': 'Atlantic 10',
  'Rider': 'Metro Conference', 'Robert Morris': 'Horizon League', 'Rutgers': 'Big Ten',
  'SIU Edwardsville': 'Ohio Valley', 'SMU': 'ACC', 'Sacramento State': 'Big West',
  'Sacred Heart': 'Metro Conference', 'Saint Francis (PA)': 'NEC', 'Saint Joseph\'s': 'Atlantic 10',
  'Saint Louis': 'Atlantic 10', 'Saint Mary\'s': 'West Coast', 'Saint Peter\'s': 'Metro Conference',
  'Sam Houston State': 'Conference USA', 'Samford': 'Southern', 'San Diego': 'West Coast',
  'San Diego State': 'Pac-12', 'San Francisco': 'West Coast', 'San Jose State': 'Mountain West',
  'Santa Clara': 'West Coast', 'Seattle': 'West Coast', 'Seton Hall': 'Big East',
  'Siena': 'Metro Conference', 'South Alabama': 'Sun Belt', 'South Carolina': 'SEC',
  'South Carolina State': 'MEAC', 'South Dakota': 'Summit League', 'South Dakota State': 'Summit League',
  'South Florida': 'American', 'Southeast Missouri State': 'Ohio Valley', 'Southeastern Louisiana': 'Southland',
  'Southern': 'SWAC', 'Southern Illinois': 'Missouri Valley', 'Southern Indiana': 'Ohio Valley',
  'Southern Methodist': 'ACC', 'Southern Mississippi': 'Sun Belt', 'Southern Utah': 'Big Sky',
  'St. Bonaventure': 'Atlantic 10', 'St. John\'s': 'Big East', 'St. Thomas': 'Summit League',
  'Stanford': 'ACC', 'Stephen F. Austin': 'Southland', 'Stetson': 'ASUN',
  'Stonehill': 'NEC', 'Stony Brook': 'CAA', 'Syracuse': 'ACC',
  'TCU': 'Big 12', 'Tarleton State': 'UAC', 'Temple': 'American',
  'Tennessee': 'SEC', 'Tennessee State': 'Ohio Valley', 'Tennessee Tech': 'Southern',
  'Texas': 'SEC', 'Texas A&M': 'SEC', 'Texas A&M-Commerce': 'Southland',
  'Texas A&M-Corpus Christi': 'Southland', 'Texas Southern': 'SWAC', 'Texas State': 'Pac-12',
  'Texas Tech': 'Big 12', 'The Citadel': 'Southern', 'Toledo': 'MAC',
  'Towson': 'CAA', 'Troy': 'Sun Belt', 'Tulane': 'American',
  'Tulsa': 'American', 'UAB': 'American', 'UC Davis': 'Mountain West',
  'UC Irvine': 'Big West', 'UC Riverside': 'Big West', 'UC San Diego': 'Big West',
  'UC Santa Barbara': 'Big West', 'UCF': 'Big 12', 'UCLA': 'Big Ten',
  'UMBC': 'America East', 'UMass': 'MAC', 'UMass Lowell': 'America East',
  'UNC Asheville': 'Big South', 'UNC Greensboro': 'Southern', 'UNC Wilmington': 'CAA',
  'UNLV': 'Mountain West', 'USC': 'Big Ten', 'USC Upstate': 'Big South',
  'UT Arlington': 'UAC', 'UT Martin': 'Ohio Valley', 'UT Rio Grande Valley': 'Southland',
  'UTEP': 'Mountain West', 'UTSA': 'American', 'Utah': 'Big 12',
  'Utah State': 'Pac-12', 'Utah Tech': 'Big Sky', 'Utah Valley': 'Big West',
  'Valparaiso': 'Missouri Valley', 'Vanderbilt': 'SEC', 'Vermont': 'America East',
  'Villanova': 'Big East', 'Virginia': 'ACC', 'Virginia Commonwealth': 'Atlantic 10',
  'Virginia Military Institute': 'Southern', 'Virginia Tech': 'ACC', 'Wagner': 'NEC',
  'Wake Forest': 'ACC', 'Washington': 'Big Ten', 'Washington State': 'Pac-12',
  'Weber State': 'Big Sky', 'West Georgia': 'UAC', 'West Virginia': 'Big 12',
  'Western Carolina': 'Southern', 'Western Illinois': 'Ohio Valley', 'Western Kentucky': 'Conference USA',
  'Western Michigan': 'MAC', 'Wichita State': 'American', 'William & Mary': 'CAA',
  'Winthrop': 'Big South', 'Wisconsin': 'Big Ten', 'Wofford': 'Southern',
  'Wright State': 'Horizon League', 'Wyoming': 'Mountain West', 'Xavier': 'Big East',
  'Yale': 'Ivy League', 'Youngstown State': 'Horizon League',
};

// ---- Team badges: colored initials, generated locally - no logo assets or
// licensing required. Real primary school colors for well-known programs
// (colors themselves are just facts, not trademarked artwork); any team not
// in this list falls back to a deterministic hash-based color so every team
// still gets a distinct, consistent badge.
const TEAM_COLORS = {
  'Abilene Christian': '#4E2A84', 'Air Force': '#003087', 'Akron': '#00285E', 'Alabama': '#9E1B32',
  'Alabama A&M': '#861F41', 'Alabama State': '#D4A017', 'Albany': '#461D7C', 'Alcorn State': '#4B116F',
  'American': '#A6192E', 'Appalachian State': '#FFCC00', 'Arizona': '#CC0033', 'Arizona State': '#8C1D40',
  'Arkansas': '#9D2235', 'Arkansas State': '#CC092F', 'Arkansas-Pine Bluff': '#4B2E83', 'Army': '#B58500',
  'Auburn': '#0C2340', 'Austin Peay': '#A32638', 'BYU': '#002E5D', 'Ball State': '#BA0C2F',
  'Baylor': '#154734', 'Bellarmine': '#A6192E', 'Belmont': '#002F6C', 'Bethune-Cookman': '#862633',
  'Binghamton': '#005A43', 'Boise State': '#0033A0', 'Boston College': '#98002E', 'Boston University': '#CC0000',
  'Bowling Green': '#FE5000', 'Bradley': '#C8102E', 'Brown': '#4E3629', 'Bryant': '#FDB827',
  'Bucknell': '#FF7B00', 'Buffalo': '#005BBB', 'Butler': '#13294B', 'Cal Poly': '#154734',
  'Cal State Bakersfield': '#003DA5', 'Cal State Fullerton': '#002E6D', 'Cal State Northridge': '#C41230', 'California': '#003262',
  'California Baptist': '#003B75', 'Campbell': '#FF6600', 'Canisius': '#00539B', 'Central Arkansas': '#4B2E83',
  'Central Connecticut State': '#002F6C', 'Central Michigan': '#6A0032', 'Charleston Southern': '#006747', 'Charlotte': '#00703C',
  'Chattanooga': '#00285E', 'Chicago State': '#006A44', 'Cincinnati': '#E00122', 'Citadel': '#002D62',
  'Clemson': '#F56600', 'Cleveland State': '#006747', 'Coastal Carolina': '#006F71', 'Colgate': '#870F3B',
  'College of Charleston': '#6C1D45', 'Colorado': '#CFB87C', 'Colorado State': '#1E4D2B', 'Columbia': '#B9D9EB',
  'Connecticut': '#000E2F', 'Coppin State': '#002F6C', 'Cornell': '#B31B1B', 'Creighton': '#003DA5',
  'Dartmouth': '#00693E', 'Davidson': '#A6192E', 'Dayton': '#CE1141', 'DePaul': '#005EB8',
  'Delaware': '#00539F', 'Delaware State': '#CE1126', 'Denver': '#862633', 'Detroit Mercy': '#C8102E',
  'Drake': '#003087', 'Drexel': '#07294D', 'Duke': '#003087', 'Duquesne': '#C8102E',
  'East Carolina': '#592A8A', 'East Tennessee State': '#041E42', 'Eastern Illinois': '#0033A0', 'Eastern Kentucky': '#862633',
  'Eastern Michigan': '#006633', 'Eastern Washington': '#A10022', 'Elon': '#862633', 'Evansville': '#4B2E83',
  'Fairfield': '#C8102E', 'Fairleigh Dickinson': '#003876', 'Florida': '#0021A5', 'Florida A&M': '#F58026',
  'Florida Atlantic': '#003366', 'Florida Gulf Coast': '#00543C', 'Florida International': '#081E3F', 'Florida State': '#782F40',
  'Fordham': '#860038', 'Fresno State': '#C41230', 'Furman': '#4B2E83', 'Gardner-Webb': '#A6192E',
  'George Mason': '#006633', 'George Washington': '#00308F', 'Georgetown': '#041E42', 'Georgia': '#BA0C2F',
  'Georgia Southern': '#041E42', 'Georgia State': '#0039A6', 'Georgia Tech': '#B3A369', 'Gonzaga': '#041E42',
  'Grambling State': '#C5B358', 'Grand Canyon': '#522398', 'Green Bay': '#00694E', 'Hampton': '#002F6C',
  'Harvard': '#A51C30', 'Hawaii': '#024731', 'High Point': '#663399', 'Hofstra': '#002E5D',
  'Holy Cross': '#632D62', 'Houston': '#C8102E', 'Houston Christian': '#C8102E', 'Howard': '#003087',
  'Idaho': '#FFB300', 'Idaho State': '#F47321', 'Illinois': '#E84A27', 'Illinois State': '#CE1126',
  'Illinois-Chicago': '#002B5C', 'Incarnate Word': '#A6192E', 'Indiana': '#990000', 'Indiana State': '#041E42',
  'Indiana University Indianapolis': '#CC0000', 'Iona': '#862633', 'Iowa': '#FFCD00', 'Iowa State': '#C8102E',
  'Jackson State': '#00205B', 'Jacksonville': '#004F27', 'Jacksonville State': '#A6192E', 'James Madison': '#450084',
  'Kansas': '#0051BA', 'Kansas City': '#00518C', 'Kansas State': '#512888', 'Kennesaw State': '#FDB827',
  'Kent State': '#002664', 'Kentucky': '#0033A0', 'LIU': '#002147', 'LSU': '#461D7C',
  'La Salle': '#00205B', 'Lafayette': '#870019', 'Lamar': '#C8102E', 'Le Moyne': '#00594C',
  'Lehigh': '#6F4A23', 'Liberty': '#002D72', 'Lindenwood': '#4B2E83', 'Lipscomb': '#492E7C',
  'Little Rock': '#7A1129', 'Long Beach State': '#FDB827', 'Long Island': '#002147', 'Longwood': '#003876',
  'Louisiana': '#CE181E', 'Louisiana Tech': '#C41230', 'Louisiana-Monroe': '#870032', 'Louisville': '#AD0000',
  'Loyola Chicago': '#9E1B32', 'Loyola Maryland': '#007041', 'Loyola Marymount': '#A6192E', 'Maine': '#002D62',
  'Manhattan': '#00563F', 'Marist': '#C8102E', 'Marquette': '#003366', 'Marshall': '#00693E',
  'Maryland': '#E03A3E', 'Maryland Eastern Shore': '#7A1229', 'Massachusetts': '#881C1C', 'McNeese State': '#00205B',
  'Memphis': '#003087', 'Mercer': '#F15A22', 'Mercyhurst': '#046A38', 'Merrimack': '#002D62',
  'Miami (FL)': '#F47321', 'Miami (OH)': '#C41230', 'Michigan': '#00274C', 'Michigan State': '#18453B',
  'Middle Tennessee': '#0066CC', 'Milwaukee': '#FFC72C', 'Minnesota': '#7A0019', 'Mississippi State': '#660000',
  'Mississippi Valley State': '#00563F', 'Missouri': '#F1B82D', 'Missouri State': '#8B2131', 'Monmouth': '#041E42',
  'Montana': '#7A1129', 'Montana State': '#00205B', 'Morehead State': '#002D72', 'Morgan State': '#002469',
  'Mount St. Mary\'s': '#002D72', 'Murray State': '#002144', 'NC State': '#CC0000', 'NJIT': '#CC0000',
  'Navy': '#00205B', 'Nebraska': '#E41C38', 'Nevada': '#003366', 'New Hampshire': '#00205B',
  'New Haven': '#002D72', 'New Mexico': '#BA0C2F', 'New Mexico State': '#862633', 'New Orleans': '#002F6C',
  'Niagara': '#4B2E83', 'Nicholls State': '#A6192E', 'Norfolk State': '#00594C', 'North Alabama': '#4B2E83',
  'North Carolina': '#7BAFD4', 'North Carolina A&T': '#002469', 'North Carolina Central': '#862633', 'North Dakota': '#009A44',
  'North Dakota State': '#FFC82E', 'North Florida': '#002F6C', 'North Texas': '#00853E', 'Northeastern': '#C8102E',
  'Northern Arizona': '#002D72', 'Northern Colorado': '#004884', 'Northern Illinois': '#C8102E', 'Northern Iowa': '#4B2E83',
  'Northern Kentucky': '#E5A823', 'Northwestern': '#4E2A84', 'Northwestern State': '#4B2E83', 'Notre Dame': '#0C2340',
  'Oakland': '#FFC629', 'Ohio': '#00694E', 'Ohio State': '#BB0000', 'Oklahoma': '#841617',
  'Oklahoma State': '#FF7300', 'Old Dominion': '#003057', 'Omaha': '#D00000', 'Oral Roberts': '#002D62',
  'Oregon': '#154733', 'Oregon State': '#DC4405', 'Pacific': '#F58025', 'Penn State': '#041E42',
  'Pennsylvania': '#990000', 'Pepperdine': '#04225C', 'Pittsburgh': '#003594', 'Portland': '#5B2B82',
  'Portland State': '#00553C', 'Prairie View A&M': '#4B2E83', 'Presbyterian': '#002D72', 'Princeton': '#FF8F1C',
  'Providence': '#000000', 'Purdue': '#CEB888', 'Purdue Fort Wayne': '#003057', 'Queens': '#002D72',
  'Quinnipiac': '#00205B', 'Radford': '#A6192E', 'Rhode Island': '#003DA5', 'Rice': '#00205B',
  'Richmond': '#A6192E', 'Rider': '#C8102E', 'Robert Morris': '#002D72', 'Rutgers': '#CC0033',
  'SIU Edwardsville': '#CC0000', 'SMU': '#C8102E', 'Sacramento State': '#043927', 'Sacred Heart': '#C8102E',
  'Saint Francis (PA)': '#C8102E', 'Saint Joseph\'s': '#9E1B32', 'Saint Louis': '#003DA5', 'Saint Mary\'s': '#C8102E',
  'Saint Peter\'s': '#00205B', 'Sam Houston State': '#F15A22', 'Samford': '#862633', 'San Diego': '#003B7C',
  'San Diego State': '#A6192E', 'San Francisco': '#00543C', 'San Jose State': '#0055A2', 'Santa Clara': '#862633',
  'Seattle': '#C8102E', 'Seton Hall': '#00205B', 'Siena': '#046A38', 'South Alabama': '#00205B',
  'South Carolina': '#73000A', 'South Carolina State': '#73000A', 'South Dakota': '#CC0000', 'South Dakota State': '#0033A0',
  'South Florida': '#006747', 'Southeast Missouri State': '#A6192E', 'Southeastern Louisiana': '#00543C', 'Southern': '#002D72',
  'Southern Illinois': '#720E1E', 'Southern Indiana': '#CE1126', 'Southern Methodist': '#C8102E', 'Southern Mississippi': '#FFAB00',
  'Southern Utah': '#A6192E', 'St. Bonaventure': '#6F4A23', 'St. John\'s': '#BA0C2F', 'St. Thomas': '#4B2E83',
  'Stanford': '#8C1515', 'Stephen F. Austin': '#4B2E83', 'Stetson': '#046A38', 'Stonehill': '#002D62',
  'Stony Brook': '#A6192E', 'Syracuse': '#F76900', 'TCU': '#4D1979', 'Tarleton State': '#4B2E83',
  'Temple': '#9E1B32', 'Tennessee': '#FF8200', 'Tennessee State': '#002145', 'Tennessee Tech': '#4B2E83',
  'Texas': '#BF5700', 'Texas A&M': '#500000', 'Texas A&M-Commerce': '#002D72', 'Texas A&M-Corpus Christi': '#002D72',
  'Texas Southern': '#862633', 'Texas State': '#501214', 'Texas Tech': '#CC0000', 'The Citadel': '#002D62',
  'Toledo': '#00205B', 'Towson': '#FFC72C', 'Troy': '#862633', 'Tulane': '#006747',
  'Tulsa': '#002D72', 'UAB': '#1E6B52', 'UC Davis': '#002855', 'UC Irvine': '#0064B0',
  'UC Riverside': '#003DA5', 'UC San Diego': '#182B49', 'UC Santa Barbara': '#003660', 'UCF': '#BA9B37',
  'UCLA': '#2D68C4', 'UMBC': '#FDB913', 'UMass': '#881C1C', 'UMass Lowell': '#002D72',
  'UNC Asheville': '#0033A0', 'UNC Greensboro': '#002D72', 'UNC Wilmington': '#007377', 'UNLV': '#CF0A2C',
  'USC': '#990000', 'USC Upstate': '#492E7C', 'UT Arlington': '#0064B1', 'UT Martin': '#F47321',
  'UT Rio Grande Valley': '#FF8200', 'UTSA': '#0C2340', 'Utah': '#CC0000', 'Utah State': '#0F2439',
  'Utah Tech': '#CE1126', 'Utah Valley': '#275D38', 'Valparaiso': '#6F4A23', 'Vanderbilt': '#866D4B',
  'Vermont': '#00563F', 'Villanova': '#00205B', 'Virginia': '#232D4B', 'Virginia Commonwealth': '#F9A01B',
  'Virginia Military Institute': '#CC0000', 'Virginia Tech': '#630031', 'Wagner': '#046A38', 'Wake Forest': '#9E7E38',
  'Washington': '#4B2E83', 'Washington State': '#981E32', 'Weber State': '#4B2E83', 'West Georgia': '#002D72',
  'West Virginia': '#002855', 'Western Carolina': '#4B2E83', 'Western Illinois': '#4B2E83', 'Western Kentucky': '#C8102E',
  'Western Michigan': '#6C4023', 'Wichita State': '#FFC629', 'William & Mary': '#115740', 'Winthrop': '#74122B',
  'Wisconsin': '#C5050C', 'Wofford': '#B08D57', 'Wright State': '#00542F', 'Wyoming': '#4F2C1D',
  'Xavier': '#0C2340', 'Yale': '#00356B', 'Youngstown State': '#C8102E',
};

const BADGE_COLORS = ['#E63958', '#3D8BFD', '#2DD4A7', '#F5A623', '#9B5DE5', '#00C2CC', '#FF6A3D', '#5C7AEA', '#E0C341', '#4CD787', '#FF6FA5', '#7C93A8'];

const getTeamBadgeColor = (name) => {
  if (!name) return BADGE_COLORS[0];
  if (TEAM_COLORS[name]) return TEAM_COLORS[name];
  let hash = 0;
  for (let i = 0; i < name.length; i++) {
    hash = (hash * 31 + name.charCodeAt(i)) % 2147483647;
  }
  return BADGE_COLORS[Math.abs(hash) % BADGE_COLORS.length];
};

// Real school colors are often dark (navy, maroon, purple) so badge text
// needs to switch between light and dark depending on the background.
const getContrastTextColor = (hex) => {
  const clean = hex.replace('#', '');
  const r = parseInt(clean.substring(0, 2), 16);
  const g = parseInt(clean.substring(2, 4), 16);
  const b = parseInt(clean.substring(4, 6), 16);
  const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
  return luminance > 0.6 ? '#0B1120' : '#FFFFFF';
};

const getTeamInitials = (name) => {
  if (!name) return '';
  const clean = name.replace(/\([^)]*\)/g, '').replace(/'/g, '').trim();
  const words = clean.split(/[^A-Za-z]+/).filter(Boolean);
  if (words.length === 1) {
    const w = words[0];
    if (w === w.toUpperCase() && w.length <= 3) return w;
    return w.slice(0, 3).toUpperCase();
  }
  return words.slice(0, 3).map(w => w[0].toUpperCase()).join('');
};

// Every distinct conference that appears among your teams - used to check
// that a "complete" bracket has at least one team from each one.
const ALL_CONFERENCES = [...new Set(Object.values(TEAM_CONFERENCES))].sort();

const TeamBadge = ({ team }) => {
  const bg = getTeamBadgeColor(team);
  return (
    <span className="team-badge" style={{ backgroundColor: bg, color: getContrastTextColor(bg) }}>
      {getTeamInitials(team)}
    </span>
  );
};

function App() {
  const initialBracket = {
    'East': [
      { seed: 1, team: null, round: 1, matchup: 0, playInLinked: false, linkedMatchup: null },
      { seed: 16, team: null, round: 1, matchup: 0, playInLinked: false, linkedMatchup: null },
      { seed: 8, team: null, round: 1, matchup: 1, playInLinked: false, linkedMatchup: null },
      { seed: 9, team: null, round: 1, matchup: 1, playInLinked: false, linkedMatchup: null },
      { seed: 5, team: null, round: 1, matchup: 2, playInLinked: false, linkedMatchup: null },
      { seed: 12, team: null, round: 1, matchup: 2, playInLinked: false, linkedMatchup: null },
      { seed: 4, team: null, round: 1, matchup: 3, playInLinked: false, linkedMatchup: null },
      { seed: 13, team: null, round: 1, matchup: 3, playInLinked: false, linkedMatchup: null },
      { seed: 6, team: null, round: 1, matchup: 4, playInLinked: false, linkedMatchup: null },
      { seed: 11, team: null, round: 1, matchup: 4, playInLinked: false, linkedMatchup: null },
      { seed: 3, team: null, round: 1, matchup: 5, playInLinked: false, linkedMatchup: null },
      { seed: 14, team: null, round: 1, matchup: 5, playInLinked: false, linkedMatchup: null },
      { seed: 7, team: null, round: 1, matchup: 6, playInLinked: false, linkedMatchup: null },
      { seed: 10, team: null, round: 1, matchup: 6, playInLinked: false, linkedMatchup: null },
      { seed: 2, team: null, round: 1, matchup: 7, playInLinked: false, linkedMatchup: null },
      { seed: 15, team: null, round: 1, matchup: 7, playInLinked: false, linkedMatchup: null },
    ],
    'West': [],
    'South': [],
    'Midwest': [],
    'Play-in': defaultOpeningRoundConfig.flatMap((config, m) => ([
      { seed: config.seed, team: null, pair: m + 1, round: 0, matchup: m },
      { seed: config.seed, team: null, pair: m + 1, round: 0, matchup: m },
    ])),
  };

  ['West', 'South', 'Midwest'].forEach(region => {
    if (!initialBracket[region].length) {
      initialBracket[region] = initialBracket.East.map(slot => ({ ...slot }));
    }
  });

  const [bracket, setBracket] = useState(initialBracket);
  const [selectedTeam, setSelectedTeam] = useState('');
  const [searchTerm, setSearchTerm] = useState('');
  const [conferenceFilter, setConferenceFilter] = useState('');
  const [activeTab, setActiveTab] = useState('bracket');
  const [playInConfig, setPlayInConfig] = useState(defaultOpeningRoundConfig);
  const [user, setUser] = useState(null);
  const [saveStatus, setSaveStatus] = useState('');
  const [customTitle, setCustomTitle] = useState('');
  const [bubbleWatch, setBubbleWatch] = useState({
    lastIn: [null, null, null, null],
    firstOut: [null, null, null, null],
    nextOut: [null, null, null, null],
  });
  const [includeBubbleWatchInExport, setIncludeBubbleWatchInExport] = useState(true);
  const [prevBracket, setPrevBracket] = useState(null);
  const [showBracketUndo, setShowBracketUndo] = useState(false);
  const [bracketSwapMode, setBracketSwapMode] = useState(false);
  const [bracketSwapSlot, setBracketSwapSlot] = useState(null);
  const [regionOrder, setRegionOrder] = useState(['East', 'West', 'South', 'Midwest']);
  const [showContactPopup, setShowContactPopup] = useState(false);
  const [showHelpPopup, setShowHelpPopup] = useState(false);
  const [authLoading, setAuthLoading] = useState(true);
  const [notification, setNotification] = useState(null);
  const [savedBrackets, setSavedBrackets] = useState([]);
  const [currentBracketId, setCurrentBracketId] = useState(null);
  const [showBracketsPanel, setShowBracketsPanel] = useState(false);
  const [deleteConfirm, setDeleteConfirm] = useState(null);
  const [wasComplete, setWasComplete] = useState(false);
  const [localDraft, setLocalDraft] = useState(null);

  const DRAFT_KEY = 'mybracket_local_draft';

  const notify = (message, type = 'error') => setNotification({ message, type });

  const regions = ['East', 'West', 'South', 'Midwest'];
  const atLargePossibleSeeds = [10, 11, 12, 13, 14];

  // Single source of truth: the Seed List view is derived directly from the
  // same `bracket` state the Region List renders, grouped by seed number
  // instead of by region. Editing either view edits the exact same slot, so
  // there's nothing to keep "in sync" - they're the same data, two layouts.
  const getSeedGroups = () => {
    const groups = {};
    for (let s = 1; s <= 16; s++) groups[s] = [];
    regionOrder.forEach(region => {
      bracket[region].forEach((slot, index) => {
        if (slot.playInLinked) {
          const m = slot.linkedMatchup;
          const pairSlots = bracket['Play-in'] || [];
          [m * 2, m * 2 + 1].forEach(pIdx => {
            groups[slot.seed].push({
              region: 'Play-in',
              index: pIdx,
              team: pairSlots[pIdx]?.team || null,
              label: `${region} Opening Round`,
            });
          });
        } else {
          const upSlot = bracket[region].find(s2 => s2.seed === slot.seed - 1);
          const downSlot = bracket[region].find(s2 => s2.seed === slot.seed + 1);
          groups[slot.seed].push({
            region, index, team: slot.team, label: region,
            canMoveUp: !!upSlot && !upSlot.playInLinked,
            canMoveDown: !!downSlot && !downSlot.playInLinked,
          });
        }
      });
    });
    return groups;
  };

  // Every team currently sitting anywhere on the board - region slots (not the
  // merged "TeamA OR TeamB" placeholder ones) plus every Opening Round slot.
  // Computed live from `bracket` on every render so it can never go stale,
  // which is what makes duplicate placement impossible: a team that's already
  // on the board simply never appears in the dropdown/search again.
  const getPlacedTeams = () => {
    const placed = new Set();
    regions.forEach(region => {
      bracket[region].forEach(slot => slot.team && !slot.playInLinked && placed.add(slot.team));
    });
    bracket['Play-in']?.forEach(slot => slot.team && placed.add(slot.team));
    return placed;
  };

  const getAvailableTeams = () => {
    const placed = getPlacedTeams();
    return allTeams.filter(t => !placed.has(t));
  };

  const shuffleArray = (array) => {
    const shuffled = [...array];
    for (let i = shuffled.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
    }
    return shuffled;
  };

  const availableTeams = getAvailableTeams();

  useEffect(() => {
    if (!notification) return;
    const timer = setTimeout(() => setNotification(null), 5000);
    return () => clearTimeout(timer);
  }, [notification]);

  useEffect(() => {
    const complete = isBracketFull() && getMissingConferences().length === 0;
    if (complete && !wasComplete) {
      notify('🎉 Bracket complete! Every team is placed — ready to save or export.', 'success');
    }
    if (complete !== wasComplete) setWasComplete(complete);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [bracket]);

  // Check for a leftover local draft once, on first load.
  useEffect(() => {
    try {
      const raw = localStorage.getItem(DRAFT_KEY);
      if (raw) {
        const draft = JSON.parse(raw);
        if (draft && draft.filledCount > 0) setLocalDraft(draft);
      }
    } catch (e) {
      console.error(e);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Show the "how this works" help modal automatically the first time
  // someone visits - never again after that, but still reachable anytime
  // via the "?" button.
  useEffect(() => {
    try {
      if (!localStorage.getItem('mybracket_onboarding_seen')) {
        setShowHelpPopup(true);
        localStorage.setItem('mybracket_onboarding_seen', 'true');
      }
    } catch (e) {
      console.error(e);
    }
  }, []);

  // Auto-save the current board to localStorage as you work, debounced so it
  // doesn't write on every keystroke/click. Separate from the "My Brackets"
  // cloud saves - this is just a local safety net against an accidental
  // refresh or closed tab.
  useEffect(() => {
    if (localDraft) return; // don't overwrite an unreviewed draft prompt
    const filled = getFilledCount();
    if (filled === 0) return;
    const timer = setTimeout(() => {
      try {
        localStorage.setItem(DRAFT_KEY, JSON.stringify({
          bracket, regionOrder, playInConfig, customTitle, bubbleWatch,
          filledCount: filled,
          savedAt: Date.now(),
        }));
      } catch (e) {
        console.error(e);
      }
    }, 800);
    return () => clearTimeout(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [bracket, regionOrder, playInConfig, customTitle, bubbleWatch]);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      setUser(currentUser);
      if (currentUser) {
        loadSavedBracketsList(currentUser.uid);
      } else {
        setSavedBrackets([]);
      }
      setAuthLoading(false);
    });
    return unsubscribe;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const updateBracketWithConfig = () => {
    const newBracket = { ...bracket };
    regions.forEach(region => {
      newBracket[region].forEach(slot => {
        if (slot.playInLinked) {
          slot.playInLinked = false;
          slot.linkedMatchup = null;
          if (slot.team && slot.team.includes(' OR ')) slot.team = null;
        }
      });
    });
    playInConfig.forEach((config, m) => {
      const linkedSlot = newBracket[config.region].find(slot => slot.seed === config.seed);
      if (linkedSlot) {
        linkedSlot.playInLinked = true;
        linkedSlot.linkedMatchup = m;
      }
      newBracket['Play-in'][m * 2].seed = config.seed;
      newBracket['Play-in'][m * 2 + 1].seed = config.seed;
    });
    setBracket(newBracket);
  };

  useEffect(() => {
    updateBracketWithConfig();
    updatePlayInWinners();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [playInConfig]);

  const updatePlayInWinners = (newBracket = bracket) => {
    const updatedBracket = { ...newBracket };
    const playInSlots = updatedBracket['Play-in'] || [];
    playInConfig.forEach((config, m) => {
      const team1 = playInSlots[m * 2]?.team;
      const team2 = playInSlots[m * 2 + 1]?.team;
      const linkedSlot = updatedBracket[config.region]?.find(slot => slot.playInLinked && slot.linkedMatchup === m);
      if (linkedSlot) {
        if (team1 && team2) linkedSlot.team = `${team1} OR ${team2}`;
        else if (linkedSlot.team && linkedSlot.team.includes(' OR ')) linkedSlot.team = null;
      }
    });
    setBracket(updatedBracket);
  };

  const handleConfigChange = (index, field, value) => {
    const config = playInConfig[index];

    if (config.locked) {
      notify('This is an automatic-qualifier game, fixed by NCAA rule (4 games at seed 16, 2 at seed 15) - only the region for the seed-15 games below can be adjusted, or the at-large games.');
      return;
    }
    if (field === 'seed' && config.seedLocked) {
      notify('This seed-15 automatic-qualifier game is fixed at seed 15 by NCAA rule - but which region hosts it is adjustable, since that\'s the committee\'s own call.');
      return;
    }

    const newRegion = field === 'region' ? value : config.region;
    const newSeed = field === 'seed' ? parseInt(value) : config.seed;

    // A region can only have ONE Opening Round game per seed line - it's not
    // possible in the real tournament for two different games to both feed
    // into e.g. the East region's 16-seed slot.
    const collision = playInConfig.some((c, i) => i !== index && c.region === newRegion && c.seed === newSeed);
    if (collision) {
      notify(`${newRegion} already has an Opening Round game at seed ${newSeed} - pick a different ${field === 'region' ? 'region' : 'seed'}.`);
      return;
    }

    // Build a genuinely new entry rather than mutating the shared object in
    // place, which previously risked corrupting defaultOpeningRoundConfig itself.
    const newConfig = playInConfig.map((c, i) => (i === index ? { ...c, region: newRegion, seed: newSeed } : c));
    setPlayInConfig(newConfig);
  };

  const handleTeamSelect = (eventOrTeam) => {
    const team = typeof eventOrTeam === 'string' ? eventOrTeam : eventOrTeam.target.value;
    setSelectedTeam(team);
    setSearchTerm('');
  };

  const handleSearchChange = (e) => setSearchTerm(e.target.value);
  const handleTitleChange = (e) => setCustomTitle(e.target.value);

  const handleBracketDragStart = (e, region, index) => {
    e.dataTransfer.setData('text/plain', `bracket-${region}-${index}`);
  };

  const handleRegionDragStart = (e, region) => {
    e.dataTransfer.setData('text/plain', `region-${region}`);
  };

  const handleDragOver = e => e.preventDefault();
  const handleDragEnter = e => e.preventDefault();
  const handleDragLeave = () => {};

  const handleBracketDrop = (e, region, index) => {
    e.preventDefault();
    const data = e.dataTransfer.getData('text/plain');
    if (data.startsWith('bracket-')) {
      const [, sourceRegion, sourceIndexStr] = data.split('-');
      const sourceIndex = parseInt(sourceIndexStr, 10);
      if (sourceRegion === region && sourceIndex === index) return;
      const newBracket = { ...bracket };
      const temp = newBracket[sourceRegion][sourceIndex].team;
      newBracket[sourceRegion][sourceIndex].team = newBracket[region][index].team;
      newBracket[region][index].team = temp;
      setBracket(newBracket);
      if (region === 'Play-in' || sourceRegion === 'Play-in') updatePlayInWinners(newBracket);
      setPrevBracket(JSON.parse(JSON.stringify(bracket)));
      setShowBracketUndo(true);
    }
  };

  const handleRegionDrop = (e, targetRegion) => {
    e.preventDefault();
    const data = e.dataTransfer.getData('text/plain');
    if (data.startsWith('region-')) {
      const sourceRegion = data.split('-')[1];
      if (sourceRegion === targetRegion) return;
      const newOrder = [...regionOrder];
      const sourceIndex = newOrder.indexOf(sourceRegion);
      const targetIndex = newOrder.indexOf(targetRegion);
      newOrder.splice(sourceIndex, 1);
      newOrder.splice(targetIndex, 0, sourceRegion);
      setRegionOrder(newOrder);
    }
  };

  const isBracketFull = () => {
    let filled = 0;
    let total = 0;

    bracket['Play-in']?.forEach(slot => {
      total++;
      if (slot.team) filled++;
    });

    regions.forEach(r => {
      bracket[r].forEach(slot => {
        if (!slot.playInLinked) {
          total++;
          if (slot.team) filled++;
        }
      });
    });

    return filled === total && total === TOTAL_TEAMS;
  };

  const getFilledCount = () => {
    let filled = 0;
    bracket['Play-in']?.forEach(slot => { if (slot.team) filled++; });
    regions.forEach(r => {
      bracket[r].forEach(slot => {
        if (!slot.playInLinked && slot.team) filled++;
      });
    });
    return filled;
  };

  // What's left to fill, broken down by section - so you don't have to
  // hunt through 16 seed-list rows to find the one empty slot.
  const getIncompleteSections = () => {
    const sections = [];
    regionOrder.forEach(r => {
      const empty = bracket[r].filter(s => !s.playInLinked && !s.team).length;
      if (empty > 0) sections.push({ label: r, count: empty });
    });
    const openingEmpty = bracket['Play-in']?.filter(s => !s.team).length || 0;
    if (openingEmpty > 0) sections.push({ label: 'Opening Round', count: openingEmpty });
    return sections;
  };

  const handleRemoveAll = () => {
    setPrevBracket(JSON.parse(JSON.stringify(bracket)));
    const newBracket = { ...bracket };
    regions.forEach(region => {
      newBracket[region].forEach(slot => {
        if (!slot.playInLinked) slot.team = null;
      });
    });
    newBracket['Play-in']?.forEach(slot => slot.team = null);
    setBracket(newBracket);
    updatePlayInWinners(newBracket);
    setShowBracketUndo(true);
    setSelectedTeam('');
    setSearchTerm('');
    setBracketSwapMode(false);
    setBracketSwapSlot(null);
  };

  const handleFillRandom = () => {
    if (isBracketFull()) return notify('Bracket is already full!');

    const remaining = getAvailableTeams();
    if (remaining.length === 0) return notify('No teams left to place!');

    setPrevBracket(JSON.parse(JSON.stringify(bracket)));

    // Guarantee every conference gets at least one team, same rule the
    // validity check enforces - a pure random fill has no reason to
    // otherwise avoid skipping a smaller conference entirely.
    const missingConferences = getMissingConferences();
    const pool = [...remaining];
    const reserved = [];
    missingConferences.forEach(conf => {
      const idx = pool.findIndex(t => TEAM_CONFERENCES[t] === conf);
      if (idx !== -1) {
        reserved.push(pool[idx]);
        pool.splice(idx, 1);
      }
    });

    const fillOrder = [...shuffleArray(reserved), ...shuffleArray(pool)];
    const newB = { ...bracket };
    let idx = 0;

    for (let i = 0; i < (newB['Play-in']?.length || 0) && idx < fillOrder.length; i++) {
      if (!newB['Play-in'][i].team) {
        newB['Play-in'][i].team = fillOrder[idx++];
      }
    }

    regions.forEach(r => {
      newB[r].forEach(s => {
        if (!s.playInLinked && !s.team && idx < fillOrder.length) {
          s.team = fillOrder[idx++];
        }
      });
    });

    setBracket(newB);
    updatePlayInWinners(newB);
    setShowBracketUndo(true);
    if (missingConferences.length > reserved.length) {
      notify(`Filled, but ${missingConferences.length - reserved.length} conference(s) still have no team - not enough empty slots left to cover them.`);
    }
  };

  const handleUndoRemoveAll = () => {
    if (prevBracket) {
      setBracket(prevBracket);
      updatePlayInWinners(prevBracket);
      setPrevBracket(null);
      setShowBracketUndo(false);
    }
  };

  const handleBracketSwapClick = (region, index) => {
    const slot = bracket[region][index];
    if (slot.playInLinked) return;
    if (selectedTeam) {
      if (getPlacedTeams().has(selectedTeam)) {
        notify(`${selectedTeam} is already on the board - a team can't be in two spots.`);
        setSelectedTeam('');
        return;
      }
      const newBracket = { ...bracket };
      newBracket[region][index].team = selectedTeam;
      setBracket(newBracket);
      if (region === 'Play-in') updatePlayInWinners(newBracket);
      setSelectedTeam('');
    } else if (!bracketSwapMode) {
      setBracketSwapMode(true);
      setBracketSwapSlot({ region, index });
    } else {
      if (bracketSwapSlot.region === region && bracketSwapSlot.index === index) {
        setBracketSwapMode(false);
        setBracketSwapSlot(null);
        return;
      }
      const newBracket = { ...bracket };
      const temp = newBracket[bracketSwapSlot.region][bracketSwapSlot.index].team;
      newBracket[bracketSwapSlot.region][bracketSwapSlot.index].team = newBracket[region][index].team;
      newBracket[region][index].team = temp;
      setBracket(newBracket);
      if (region === 'Play-in' || bracketSwapSlot.region === 'Play-in') updatePlayInWinners(newBracket);
      setBracketSwapMode(false);
      setBracketSwapSlot(null);
    }
  };

  // Swaps a team with whatever's in the adjacent seed line, within the same
  // region - e.g. the up arrow on a 9-seed swaps it with the current 8-seed.
  // Swaps two seed-list entries with each other - works for any combination
  // of region and Opening Round entries, since both just point at a real
  // bracket slot via {region, index}.
  // Lets any slot (styled as a div, not a real <button>) respond to Enter/Space
  // the same way a click would - the baseline for keyboard operability.
  const handleSlotKeyDown = (e, action) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      action();
    }
  };

  // Last Four In / First Four Out / Next Four Out - standard bracketology
  // bubble-watch categories. Independent of the actual 76-team bracket
  // (these are meant to include teams that DIDN'T make the field, for
  // First/Next Four Out), so team choices here aren't gated by whether
  // that team is already placed elsewhere.
  const setBubbleTeam = (category, index, team) => {
    setBubbleWatch(prev => ({
      ...prev,
      [category]: prev[category].map((t, i) => (i === index ? (team || null) : t)),
    }));
  };

  // Reorders within a single bubble-watch category (e.g. move a team from
  // 2nd to 1st in "Last Four In") - order conveys ranking here, so this
  // matters more than it would for an unordered list.
  // The three categories are really one continuous ranking (most-safely-in
  // down to furthest-out), so arrows treat them as a single 12-slot list:
  // hitting down on the last "Last Four In" spot moves that team into the
  // first "First Four Out" spot, and vice versa.
  const BUBBLE_ORDER = ['lastIn', 'firstOut', 'nextOut'];

  // Flat position across all three categories, 0-11.
  const bubbleFlatIndex = (category, index) => BUBBLE_ORDER.indexOf(category) * 4 + index;
  const bubbleTotalSlots = () => BUBBLE_ORDER.length * 4;

  const moveBubbleTeam = (category, index, direction) => {
    const flat = bubbleFlatIndex(category, index);
    const targetFlat = flat + direction;
    if (targetFlat < 0 || targetFlat >= bubbleTotalSlots()) return;

    const targetCategory = BUBBLE_ORDER[Math.floor(targetFlat / 4)];
    const targetIndex = targetFlat % 4;

    setBubbleWatch(prev => {
      const next = { ...prev };
      // Copy both affected arrays before writing, so a swap within the same
      // category still works correctly.
      next[category] = [...prev[category]];
      next[targetCategory] = category === targetCategory
        ? next[category]
        : [...prev[targetCategory]];

      const temp = next[category][index];
      next[category][index] = next[targetCategory][targetIndex];
      next[targetCategory][targetIndex] = temp;
      return next;
    });
  };

  const swapRowEntries = (a, b) => {
    if (!a || !b) return;
    const newBracket = { ...bracket };
    const temp = newBracket[a.region][a.index].team;
    newBracket[a.region][a.index].team = newBracket[b.region][b.index].team;
    newBracket[b.region][b.index].team = temp;
    setBracket(newBracket);
    if (a.region === 'Play-in' || b.region === 'Play-in') updatePlayInWinners(newBracket);
  };

  // Left/right treat the whole seed list as one continuous sequence - at the
  // start/end of a row, they wrap into the last/first entry of the
  // previous/next seed line instead of just stopping.
  const getPrevRowEntry = (seedGroups, seedValue, colIndex, rowSlots) => {
    if (colIndex > 0) return rowSlots[colIndex - 1];
    const prevRow = seedGroups[seedValue - 1];
    return prevRow && prevRow.length > 0 ? prevRow[prevRow.length - 1] : null;
  };

  const getNextRowEntry = (seedGroups, seedValue, colIndex, rowSlots) => {
    if (colIndex < rowSlots.length - 1) return rowSlots[colIndex + 1];
    const nextRow = seedGroups[seedValue + 1];
    return nextRow && nextRow.length > 0 ? nextRow[0] : null;
  };

  // Swaps a team with whatever's in the adjacent seed line, within the same
  // region - e.g. the up arrow on a 9-seed swaps it with the current 8-seed.
  const moveTeamSeed = (region, index, direction) => {
    const currentSeed = bracket[region][index].seed;
    const targetIndex = bracket[region].findIndex(s => s.seed === currentSeed + direction);
    if (targetIndex === -1 || bracket[region][targetIndex].playInLinked) return;
    const newBracket = { ...bracket };
    const temp = newBracket[region][targetIndex].team;
    newBracket[region][targetIndex].team = newBracket[region][index].team;
    newBracket[region][index].team = temp;
    setBracket(newBracket);
  };

  const placeTeam = (region, index) => {
    if (!selectedTeam) return;
    const slot = bracket[region][index];
    if (slot.team || slot.playInLinked) return;
    if (getPlacedTeams().has(selectedTeam)) {
      notify(`${selectedTeam} is already on the board - a team can't be in two spots.`);
      setSelectedTeam('');
      return;
    }
    const newB = { ...bracket };
    newB[region][index].team = selectedTeam;
    setBracket(newB);
    if (region === 'Play-in') updatePlayInWinners(newB);
    setSelectedTeam('');
  };

  const removeTeam = (region, index) => {
    const newB = { ...bracket };
    newB[region][index].team = null;
    setBracket(newB);
    if (region === 'Play-in') updatePlayInWinners(newB);
  };

  const handleGoogleLogin = async () => {
    try {
      const provider = new GoogleAuthProvider();
      await signInWithPopup(auth, provider);
    } catch (error) {
      notify(`Google login failed: ${error.message}`);
    }
  };

  const handleLogout = async () => {
    try {
      await signOut(auth);
      setCurrentBracketId(null);
      setShowBracketsPanel(false);
    } catch (error) {
      notify(`Logout failed: ${error.message}`);
    }
  };

  const getValidityError = () => {
    const missing = getMissingConferences();
    if (missing.length > 0) {
      return `Missing a team from: ${missing.join(', ')} (every conference needs at least one automatic qualifier).`;
    }
    return `Bracket incomplete - all ${TOTAL_TEAMS} teams must be placed.`;
  };

  const handleSaveBracket = () => {
    if (!user) return notify('Please sign in');
    if (!isBracketValid()) return notify(getValidityError());
    saveBracket(user.uid, bracket);
  };

  const saveBracket = async (uid, b) => {
    setSaveStatus('Saving...');
    const name = customTitle || 'My Bracket';
    const payload = {
      name,
      bracket: JSON.stringify(b),
      regionOrder: JSON.stringify(regionOrder),
      bubbleWatch: JSON.stringify(bubbleWatch),
      savedAt: serverTimestamp(),
    };
    try {
      if (currentBracketId) {
        await setDoc(doc(db, 'users', uid, 'brackets', currentBracketId), payload);
      } else {
        const newDoc = await addDoc(collection(db, 'users', uid, 'brackets'), payload);
        setCurrentBracketId(newDoc.id);
      }
      setSaveStatus('Saved');
      loadSavedBracketsList(uid);
      notify(`"${name}" saved.`, 'success');
    } catch (e) {
      setSaveStatus('Error');
      console.error('Save failed:', e);
      notify(`Save failed: ${e.code || e.message || 'unknown error'}`);
    }
  };

  const loadSavedBracketsList = async (uid) => {
    try {
      const q = query(collection(db, 'users', uid, 'brackets'), orderBy('savedAt', 'desc'));
      const snap = await getDocs(q);
      setSavedBrackets(snap.docs.map(d => ({ id: d.id, name: d.data().name || 'My Bracket' })));
    } catch (e) {
      console.error(e);
    }
  };

  const handleLoadSavedBracket = async (id) => {
    if (!user) return;
    try {
      const snap = await getDoc(doc(db, 'users', user.uid, 'brackets', id));
      if (snap.exists()) {
        const d = snap.data();
        setBracket(JSON.parse(d.bracket));
        setRegionOrder(d.regionOrder ? JSON.parse(d.regionOrder) : regionOrder);
        setBubbleWatch(d.bubbleWatch ? JSON.parse(d.bubbleWatch) : {
          lastIn: [null, null, null, null],
          firstOut: [null, null, null, null],
          nextOut: [null, null, null, null],
        });
        setCustomTitle(d.name || '');
        setCurrentBracketId(id);
        setShowBracketsPanel(false);
        notify(`Loaded "${d.name || 'My Bracket'}".`, 'success');
      }
    } catch (e) {
      console.error(e);
      notify('Failed to load that bracket.');
    }
  };

  const handleDeleteSavedBracket = async (id, name) => {
    if (!user) return;
    try {
      await deleteDoc(doc(db, 'users', user.uid, 'brackets', id));
      if (id === currentBracketId) setCurrentBracketId(null);
      loadSavedBracketsList(user.uid);
      notify(`Deleted "${name}".`, 'success');
    } catch (e) {
      console.error(e);
      notify('Failed to delete that bracket.');
    } finally {
      setDeleteConfirm(null);
    }
  };

  const handleNewBracket = () => {
    setBracket(initialBracket);
    setRegionOrder(['East', 'West', 'South', 'Midwest']);
    setPlayInConfig(defaultOpeningRoundConfig);
    setBubbleWatch({
      lastIn: [null, null, null, null],
      firstOut: [null, null, null, null],
      nextOut: [null, null, null, null],
    });
    setCustomTitle('');
    setCurrentBracketId(null);
    setSelectedTeam('');
    setSaveStatus('');
    setShowBracketsPanel(false);
    try { localStorage.removeItem(DRAFT_KEY); } catch (e) { console.error(e); }
  };

  const handleRestoreDraft = () => {
    if (!localDraft) return;
    setBracket(localDraft.bracket);
    setRegionOrder(localDraft.regionOrder || ['East', 'West', 'South', 'Midwest']);
    setPlayInConfig(localDraft.playInConfig || defaultOpeningRoundConfig);
    setBubbleWatch(localDraft.bubbleWatch || {
      lastIn: [null, null, null, null],
      firstOut: [null, null, null, null],
      nextOut: [null, null, null, null],
    });
    setCustomTitle(localDraft.customTitle || '');
    setLocalDraft(null);
    notify('Draft restored.', 'success');
  };

  const handleDiscardDraft = () => {
    try { localStorage.removeItem(DRAFT_KEY); } catch (e) { console.error(e); }
    setLocalDraft(null);
  };

  // Every conference must send at least one team - mirrors the real
  // tournament, where every D-I conference gets an automatic bid via its
  // conference champion. Only meaningful once the bracket is otherwise
  // full, so this is checked alongside (not instead of) the slot-based check.
  const getMissingConferences = () => {
    const placedConferences = new Set();
    regions.forEach(r => {
      bracket[r].forEach(slot => {
        if (slot.team && !slot.playInLinked && TEAM_CONFERENCES[slot.team]) {
          placedConferences.add(TEAM_CONFERENCES[slot.team]);
        }
      });
    });
    bracket['Play-in']?.forEach(slot => {
      if (slot.team && TEAM_CONFERENCES[slot.team]) {
        placedConferences.add(TEAM_CONFERENCES[slot.team]);
      }
    });
    return ALL_CONFERENCES.filter(c => !placedConferences.has(c));
  };

  // How many teams from each conference are currently placed in the
  // bracket, plus which specific teams - sorted most bids first, since
  // that's usually the more interesting way to scan this.
  const getConferenceBreakdown = () => {
    const byConf = {};
    ALL_CONFERENCES.forEach(c => { byConf[c] = []; });
    regions.forEach(r => {
      bracket[r].forEach(slot => {
        if (slot.team && !slot.playInLinked && TEAM_CONFERENCES[slot.team]) {
          byConf[TEAM_CONFERENCES[slot.team]].push({ name: slot.team, seed: slot.seed });
        }
      });
    });
    bracket['Play-in']?.forEach(slot => {
      if (slot.team && TEAM_CONFERENCES[slot.team]) {
        // Opening Round teams are still playing for that seed line, so mark
        // the seed as provisional rather than showing it as already earned.
        byConf[TEAM_CONFERENCES[slot.team]].push({ name: slot.team, seed: slot.seed, openingRound: true });
      }
    });
    return Object.entries(byConf)
      .map(([conference, teams]) => ({
        conference,
        teams: teams.sort((a, b) => a.seed - b.seed || a.name.localeCompare(b.name)),
      }))
      .sort((a, b) => b.teams.length - a.teams.length || a.conference.localeCompare(b.conference));
  };

  const isBracketValid = () =>
    regions.every(r => bracket[r].every(s => s.playInLinked || s.team)) &&
    (bracket['Play-in']?.every(s => s.team) || false) &&
    getMissingConferences().length === 0;

  const exportToPNG = () => {
    if (!isBracketValid()) {
      notify(getValidityError());
      return;
    }

    document.body.classList.add('export-mode');
    if (activeTab === 'seedList') document.body.classList.add('export-portrait');

    setTimeout(() => {
      const node = document.querySelector('.bracket-container');

      html2canvas(node, {
        scale: 2.5,
        useCORS: true,
        backgroundColor: '#0B1120',
        logging: false,
        windowWidth: activeTab === 'seedList' ? 1700 : 2560,
        scrollX: 0,
        scrollY: 0,
      })
        .then((canvas) => {
          const link = document.createElement('a');
          const date = new Date().toISOString().slice(0, 10);
          link.download = `${customTitle || 'MyBracket'}_${activeTab === 'seedList' ? 'Seeds' : activeTab === 'conferences' ? 'Conferences' : 'Bracket'}_${date}.png`;
          link.href = canvas.toDataURL('image/png');
          link.click();
        })
        .finally(() => {
          document.body.classList.remove('export-mode', 'export-portrait');
        });
    }, 600);
  };

  const handleShareOnX = async () => {
    if (!isBracketValid()) {
      notify(getValidityError());
      return;
    }

    document.body.classList.add('export-mode');
    if (activeTab === 'seedList') document.body.classList.add('export-portrait');

    setTimeout(async () => {
      const node = document.querySelector('.bracket-container');

      try {
        const canvas = await html2canvas(node, {
          scale: 2.5,
          useCORS: true,
          backgroundColor: '#0B1120',
          logging: false,
          windowWidth: activeTab === 'seedList' ? 1700 : 2560,
        });

        canvas.toBlob((blob) => {
          const file = new File([blob], 'mybracket.png', { type: 'image/png' });
          const text = `${customTitle || 'My Bracket'} — You are the bracketologist at mybracket.online!`;

          const twitterUrl = `https://twitter.com/intent/tweet?text=${encodeURIComponent(text)}`;
          window.open(twitterUrl, '_blank');

          const link = document.createElement('a');
          link.download = file.name;
          link.href = URL.createObjectURL(blob);
          link.click();

          notify('PNG downloaded! Your tweet is open — just attach the downloaded image and post!', 'success');
        });
      } catch (err) {
        notify('Failed to generate image — please try again.');
        console.error(err);
      } finally {
        document.body.classList.remove('export-mode', 'export-portrait');
      }
    }, 600);
  };

  // Renders the search/conference/team dropdown group. Used more than once
  // on the page (at the top, and again right above the bracket content) so
  // people don't have to scroll all the way back up to pick a team - all
  // instances share the same state, so they always stay in sync.
  const renderTeamSelector = (keyPrefix, poolOverride) => {
    const pool = poolOverride || availableTeams;
    const poolByConference = conferenceFilter
      ? pool.filter(t => TEAM_CONFERENCES[t] === conferenceFilter)
      : pool;
    const poolBySearch = poolByConference.filter(team =>
      team.toLowerCase().includes(searchTerm.toLowerCase())
    );
    return (
    <>
      <div className="team-selector">
        <div className="team-search-container">
          <input value={searchTerm} onChange={handleSearchChange} placeholder="Search..." className="team-search-input" />
          {searchTerm && (
            <ul className="team-suggestions">
              {poolBySearch.map(t => (
                <li key={`${keyPrefix}-${t}`} onClick={() => handleTeamSelect(t)}>{t}</li>
              ))}
            </ul>
          )}
        </div>
        <select
          value={conferenceFilter}
          onChange={(e) => setConferenceFilter(e.target.value)}
          className="conference-dropdown"
        >
          <option value="">All Conferences</option>
          {ALL_CONFERENCES.map(c => <option key={`${keyPrefix}-${c}`} value={c}>{c}</option>)}
        </select>
        <select value={selectedTeam} onChange={handleTeamSelect} className="team-dropdown">
          <option value="">Select team</option>
          {poolByConference.map(t => <option key={`${keyPrefix}-opt-${t}`} value={t}>{t}</option>)}
        </select>
        <button onClick={() => { setSelectedTeam(''); setSearchTerm(''); }} className="clear-button">Clear</button>
      </div>
    </>
    );
  };

  // Renders the Last Four In / First Four Out / Next Four Out section.
  // Shared bubbleWatch state, so it's always in sync no matter which tab
  // it's rendered on - editing it on one tab shows up on the other too.
  const renderBubbleWatch = () => (
    <>
      <label className="bubble-watch-export-toggle">
        <input
          type="checkbox"
          checked={includeBubbleWatchInExport}
          onChange={(e) => setIncludeBubbleWatchInExport(e.target.checked)}
        />
        Include Last Four In / First Four Out / Next Four Out in PNG export
      </label>

      <div className={`bubble-watch ${includeBubbleWatchInExport ? '' : 'bubble-watch-export-hidden'}`}>
        {[
          { key: 'lastIn', title: 'Last Four In' },
          { key: 'firstOut', title: 'First Four Out' },
          { key: 'nextOut', title: 'Next Four Out' },
        ].map(({ key, title }) => (
          <div key={key} className="bubble-watch-card">
            <h3>{title}</h3>
            <div className="bubble-watch-slots">
              {bubbleWatch[key].map((team, i) => (
                <div
                  key={i}
                  className={`bubble-watch-slot ${team ? 'filled' : ''}`}
                  tabIndex={0}
                  role="button"
                  aria-label={`${title}, slot ${i + 1}, ${team || 'empty'}`}
                  onClick={() => {
                    if (selectedTeam && !team) {
                      setBubbleTeam(key, i, selectedTeam);
                      setSelectedTeam('');
                    }
                  }}
                  onKeyDown={(e) => handleSlotKeyDown(e, () => {
                    if (selectedTeam && !team) {
                      setBubbleTeam(key, i, selectedTeam);
                      setSelectedTeam('');
                    }
                  })}
                >
                  {team ? (
                    <>
                      <TeamBadge team={team} />
                      <span className="bubble-watch-team-name">{team}</span>
                      <div className="bubble-watch-arrows">
                        <button
                          onClick={(e) => { e.stopPropagation(); moveBubbleTeam(key, i, -1); }}
                          disabled={bubbleFlatIndex(key, i) === 0}
                          className="seed-arrow-button"
                          aria-label={`Move ${team} up`}
                          title="Move up"
                        >
                          ▲
                        </button>
                        <button
                          onClick={(e) => { e.stopPropagation(); moveBubbleTeam(key, i, 1); }}
                          disabled={bubbleFlatIndex(key, i) === bubbleTotalSlots() - 1}
                          className="seed-arrow-button"
                          aria-label={`Move ${team} down`}
                          title="Move down"
                        >
                          ▼
                        </button>
                      </div>
                      <button
                        onClick={(e) => { e.stopPropagation(); setBubbleTeam(key, i, null); }}
                        className="bubble-watch-remove"
                        aria-label={`Remove ${team}`}
                      >
                        &times;
                      </button>
                    </>
                  ) : (
                    <span className="bubble-watch-placeholder">(Click to place)</span>
                  )}
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </>
  );

  return (
    <div className="App">
      <img src={logo} alt="MyBracket Logo" className="logo" />
      <p className="desktop-message">(best on desktop)</p>
      <p className="format-update-note">Updated for the 2026-27 NCAA Tournament: 76 teams, 12-game Opening Round.</p>

      {notification && (
        <div className={`notification-banner ${notification.type}`}>
          <span>{notification.message}</span>
          <button onClick={() => setNotification(null)} className="notification-close" aria-label="Dismiss">&times;</button>
        </div>
      )}

      {localDraft && (
        <div className="draft-banner">
          <span>
            Found an unsaved draft ({localDraft.filledCount} teams placed) from{' '}
            {new Date(localDraft.savedAt).toLocaleString('en-US', { month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit' })}.
          </span>
          <div className="draft-banner-buttons">
            <button onClick={handleRestoreDraft} className="draft-restore-button">Restore</button>
            <button onClick={handleDiscardDraft} className="draft-discard-button">Discard</button>
          </div>
        </div>
      )}

      <div className="auth-and-team-selector">
        <div className="auth-container">
          {authLoading ? (
            <p className="auth-loading">Checking sign-in status…</p>
          ) : user ? (
            <div className="user-controls">
              <p>Welcome, {user.email}</p>
              <button onClick={handleLogout} className="auth-button">Log Out</button>
              <button onClick={handleNewBracket} className="auth-button">New Bracket</button>
              <div className="brackets-menu">
                <button onClick={() => setShowBracketsPanel(v => !v)} className="auth-button">
                  My Brackets{savedBrackets.length > 0 ? ` (${savedBrackets.length})` : ''}
                </button>
                {showBracketsPanel && (
                  <div className="brackets-panel">
                    {savedBrackets.length === 0 ? (
                      <p className="brackets-empty">No saved brackets yet.</p>
                    ) : (
                      savedBrackets.map(b => (
                        <div key={b.id} className={`brackets-panel-item ${b.id === currentBracketId ? 'active' : ''}`}>
                          <span onClick={() => handleLoadSavedBracket(b.id)}>{b.name}</span>
                          <button onClick={() => setDeleteConfirm({ id: b.id, name: b.name })} className="brackets-delete">Delete</button>
                        </div>
                      ))
                    )}
                  </div>
                )}
              </div>
              <button onClick={handleSaveBracket} className="auth-button">Save Bracket</button>
              <input value={customTitle} onChange={handleTitleChange} placeholder="Custom Title for PNG/Save" className="title-input" />
              {(activeTab === 'seedList' || activeTab === 'bracket' || activeTab === 'conferences') && (
                <>
                  <button onClick={exportToPNG} className="auth-button">
                    Export {activeTab === 'seedList' ? 'Seeds' : activeTab === 'conferences' ? 'Conferences' : 'Regions'} PNG
                  </button>
                  <button onClick={handleShareOnX} className="auth-button">
                    Share on X
                  </button>
                </>
              )}
              {saveStatus && <p>{saveStatus}</p>}
            </div>
          ) : (
            <div style={{ textAlign: 'center', marginTop: '20px' }}>
              <button onClick={handleGoogleLogin} className="google-button">Sign in with Google</button>

              <p style={{
                margin: '20px auto 0',
                maxWidth: '420px',
                fontSize: '1.05em',
                color: '#d32f2f',
                fontWeight: '700',
                backgroundColor: '#ffebee',
                padding: '14px 20px',
                borderRadius: '12px',
                border: '2px solid #ffcdd2',
                lineHeight: '1.4'
              }}>
                Sign in with Google to save or export bracket
              </p>
            </div>
          )}
        </div>
      </div>

      {/* TOP RIGHT ACTIONS */}
      <div className="top-actions">
        <button onClick={() => setShowHelpPopup(true)} className="help-button" aria-label="How to use this site">
          ?
        </button>
        <a
          href="https://x.com/MyBracketOnline"
          target="_blank"
          rel="noopener noreferrer"
          className="follow-x-button"
        >
          Follow on X
        </a>
        <button onClick={() => setShowContactPopup(true)} className="contact-button">
          Contact
        </button>
      </div>

      {/* HELP / ONBOARDING POPUP */}
      {showHelpPopup && (
        <div className="contact-popup-overlay" onClick={() => setShowHelpPopup(false)}>
          <div className="contact-popup help-popup" onClick={(e) => e.stopPropagation()}>
            <h3>How This Works</h3>
            <ol className="help-steps">
              <li>Search or pick a team from the dropdown, then click any empty slot to place them.</li>
              <li>Use the arrows on a placed team to fine-tune - <strong>◀ ▶</strong> swap with the next/previous team in the seed list, <strong>▲ ▼</strong> swap with the seed line above/below in that region.</li>
              <li><strong>Swap</strong> lets you pick two specific slots to trade. <strong>Remove</strong> clears a slot.</li>
              <li>Seed List and Region List show the <em>same</em> bracket, just arranged differently - edit either one, the other updates automatically.</li>
              <li>The Opening Round section controls which seed lines have a play-in game - adjust it under the Region List tab.</li>
              <li>Sign in to save multiple brackets to your account, or export/share a finished bracket as a PNG.</li>
            </ol>
            <button onClick={() => setShowHelpPopup(false)} className="close-popup-button">Got it</button>
          </div>
        </div>
      )}

      {/* CONTACT POPUP */}
      {showContactPopup && (
        <div className="contact-popup-overlay" onClick={() => setShowContactPopup(false)}>
          <div className="contact-popup" onClick={(e) => e.stopPropagation()}>
            <h3>Contact Us</h3>
            <p>Email: <a href="mailto:mybracketonline@gmail.com">mybracketonline@gmail.com</a></p>
            <button onClick={() => setShowContactPopup(false)} className="close-popup-button">Close</button>
          </div>
        </div>
      )}

      {/* DELETE BRACKET CONFIRMATION */}
      {deleteConfirm && (
        <div className="contact-popup-overlay" onClick={() => setDeleteConfirm(null)}>
          <div className="contact-popup" onClick={(e) => e.stopPropagation()}>
            <h3>Delete "{deleteConfirm.name}"?</h3>
            <p>This can't be undone - the bracket will be permanently deleted.</p>
            <div className="delete-confirm-buttons">
              <button onClick={() => setDeleteConfirm(null)} className="close-popup-button delete-cancel-button">Cancel</button>
              <button onClick={() => handleDeleteSavedBracket(deleteConfirm.id, deleteConfirm.name)} className="close-popup-button delete-confirm-button">
                Delete
              </button>
            </div>
          </div>
        </div>
      )}

      {/* SYNCED TABS MESSAGE */}
      <p style={{ 
        fontSize: '1.1em', 
        color: 'var(--text-dim)', 
        margin: '25px 0 15px 0', 
        fontWeight: '600',
        textAlign: 'center'
      }}>
        Seed List and Region List show the same bracket — edit either one
      </p>

      <div className="completion-tracker">
        <div className="completion-bar">
          <div
            className={`completion-bar-fill ${getFilledCount() === TOTAL_TEAMS ? 'complete' : ''}`}
            style={{ width: `${(getFilledCount() / TOTAL_TEAMS) * 100}%` }}
          />
        </div>
        <span className="completion-label">{getFilledCount()} / {TOTAL_TEAMS} placed</span>
      </div>

      {getFilledCount() < TOTAL_TEAMS && (
        <p className="whats-left-hint">
          {getIncompleteSections().map((s, i) => (
            <span key={s.label}>
              {i > 0 && <span className="whats-left-sep"> · </span>}
              {s.label}: {s.count} empty
            </span>
          ))}
        </p>
      )}

      {getFilledCount() === TOTAL_TEAMS && getMissingConferences().length > 0 && (
        <p className="missing-conferences-hint">
          Missing an automatic qualifier from: {getMissingConferences().join(', ')}
        </p>
      )}

      <div className="tabs">
        <button className={`tab-button ${activeTab === 'seedList' ? 'active' : ''}`} onClick={() => setActiveTab('seedList')}>
          Seed List
        </button>
        <button className={`tab-button ${activeTab === 'bracket' ? 'active' : ''}`} onClick={() => setActiveTab('bracket')}>
          Region List
        </button>
        <button className={`tab-button ${activeTab === 'conferences' ? 'active' : ''}`} onClick={() => setActiveTab('conferences')}>
          Conferences
        </button>
        <button className={`tab-button ${activeTab === 'teamMetrics' ? 'active' : ''}`} onClick={() => setActiveTab('teamMetrics')}>
          Team Metrics
        </button>
      </div>

      <div className="bracket-container">
        {/* SEED LIST EXPORT - TITLE + DATE ABOVE LOGO */}
{activeTab === 'seedList' && (
  <div className="export-header seed-list-header">
    <div className="title-above-logo">
      <h1>{customTitle || 'My Bracket'}</h1>
      <p className="export-date">
        {new Date().toLocaleDateString('en-US', {
          month: 'long',
          day: 'numeric',
          year: 'numeric'
        })}
      </p>
    </div>
    <img src={logo} alt="MyBracket.online" className="export-logo" />
  </div>
)}

        {/* EXPORT HEADER - REGION LIST */}
        {activeTab === 'bracket' && (
          <div className="export-header">
            <div className="logo-title">
              <h1>{customTitle || 'My Bracket'} — {new Date().toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' })}</h1>
              <img src={logo} alt="MyBracket.online" className="export-logo" />
            </div>

            <div className="play-in-container">
              <h2 style={{ margin: '0 0 16px 0', fontSize: '1.4em' }}>Opening Round Games</h2>
              <div className="bracket">
                {Array.from({ length: OPENING_ROUND_GAMES }, (_, i) => i).map(matchupNum => (
                  <div key={matchupNum} className="matchup-pair" style={{ marginBottom: '12px' }}>
                    {bracket['Play-in']?.filter(slot => slot.matchup === matchupNum).map((slot, i) => (
                      <div
                        key={i}
                        className="matchup filled"
                        style={{
                          padding: '10px 14px',
                          fontSize: '1em',
                          minHeight: '44px',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          textAlign: 'center'
                        }}
                      >
                        {slot.team ? <><TeamBadge team={slot.team} />{slot.seed} {slot.team}</> : `${slot.seed} Opening Round Winner`}
                      </div>
                    ))}
                  </div>
                ))}
              </div>
            </div>
          </div>
        )}

        {/* FULL TAB CONTENT */}
        {activeTab === 'seedList' && (
          <div className="seed-list-container">
            <div className="seed-list-buttons">
              <button onClick={handleRemoveAll} className="remove-all-button">Remove All</button>
              {showBracketUndo && <button onClick={handleUndoRemoveAll} className="undo-remove-all-button">Undo</button>}
              <button onClick={handleFillRandom} className="fill-random-button">Fill Random</button>
            </div>
            <h2>Full Seed List</h2>
            <p className="seed-list-instructions">(Drag and Drop or Swap)</p>
            {renderTeamSelector('seedlist')}
            <div className="seed-list-grid">
              {(() => {
                const seedGroups = getSeedGroups();
                return Array.from({ length: 16 }, (_, i) => {
                  const seedValue = i + 1;
                  const rowSlots = seedGroups[seedValue] || [];
                  return (
                    <div key={seedValue} className="seed-list-row">
                      <div className="seed-list-row-number">{`${seedValue} seeds`}</div>
                      {rowSlots.map((entry, colIndex) => (
                        <div
                          key={`${entry.region}-${entry.index}`}
                          className={`seed-slot ${entry.team ? 'filled' : ''}`}
                          draggable={!!entry.team}
                          tabIndex={0}
                          role="button"
                          aria-label={`${entry.label}, ${seedValue} seed, ${entry.team || 'empty'}`}
                          onDragStart={(e) => handleBracketDragStart(e, entry.region, entry.index)}
                          onDragOver={handleDragOver}
                          onDragEnter={handleDragEnter}
                          onDragLeave={handleDragLeave}
                          onDrop={(e) => handleBracketDrop(e, entry.region, entry.index)}
                          onClick={(e) => {
                            e.stopPropagation();
                            if (!bracketSwapMode) placeTeam(entry.region, entry.index);
                          }}
                          onKeyDown={(e) => handleSlotKeyDown(e, () => {
                            if (!bracketSwapMode) placeTeam(entry.region, entry.index);
                          })}
                        >
                          <span className="seed-slot-text">
                            <span className="seed-slot-label">{entry.label}</span>
                            <span className="seed-slot-team">
                              {entry.team ? <><TeamBadge team={entry.team} />{entry.team}</> : '(Click to place)'}
                            </span>
                          </span>
                          {entry.team && (
                            <div className="seed-slot-arrows">
                              {entry.region !== 'Play-in' && (
                                <button
                                  onClick={(e) => { e.stopPropagation(); moveTeamSeed(entry.region, entry.index, -1); }}
                                  disabled={!entry.canMoveUp}
                                  className="seed-arrow-button arrow-up"
                                  aria-label={`Move ${entry.team} up a seed`}
                                  title="Swap with the seed line above"
                                >
                                  ▲
                                </button>
                              )}
                              <button
                                onClick={(e) => { e.stopPropagation(); swapRowEntries(entry, getPrevRowEntry(seedGroups, seedValue, colIndex, rowSlots)); }}
                                disabled={!getPrevRowEntry(seedGroups, seedValue, colIndex, rowSlots)}
                                className="seed-arrow-button arrow-left"
                                aria-label={`Move ${entry.team} left`}
                                title="Swap with the previous team in the seed list"
                              >
                                ◀
                              </button>
                              <button
                                onClick={(e) => { e.stopPropagation(); swapRowEntries(entry, getNextRowEntry(seedGroups, seedValue, colIndex, rowSlots)); }}
                                disabled={!getNextRowEntry(seedGroups, seedValue, colIndex, rowSlots)}
                                className="seed-arrow-button arrow-right"
                                aria-label={`Move ${entry.team} right`}
                                title="Swap with the next team in the seed list"
                              >
                                ▶
                              </button>
                              {entry.region !== 'Play-in' && (
                                <button
                                  onClick={(e) => { e.stopPropagation(); moveTeamSeed(entry.region, entry.index, 1); }}
                                  disabled={!entry.canMoveDown}
                                  className="seed-arrow-button arrow-down"
                                  aria-label={`Move ${entry.team} down a seed`}
                                  title="Swap with the seed line below"
                                >
                                  ▼
                                </button>
                              )}
                            </div>
                          )}
                          {entry.team && (
                            <div className="seed-slot-buttons">
                              <button onClick={(e) => { e.stopPropagation(); removeTeam(entry.region, entry.index); }} className="remove-button">Remove</button>
                              <button
                                onClick={(e) => { e.stopPropagation(); handleBracketSwapClick(entry.region, entry.index); }}
                                className={`swap-button ${bracketSwapMode && bracketSwapSlot?.region === entry.region && bracketSwapSlot?.index === entry.index ? 'swap-active' : ''}`}
                              >
                                Swap
                              </button>
                            </div>
                          )}
                        </div>
                      ))}
                    </div>
                  );
                });
              })()}
            </div>

            {renderTeamSelector('bubble-watch')}
            {renderBubbleWatch()}
          </div>
        )}

        {activeTab === 'bracket' && (
          <>
            <div className="bracket-buttons">
              <button onClick={handleRemoveAll} className="remove-all-button">Remove All</button>
              {showBracketUndo && <button onClick={handleUndoRemoveAll} className="undo-remove-all-button">Undo</button>}
              <button onClick={handleFillRandom} className="fill-random-button">Fill Random</button>
            </div>

            {renderTeamSelector('opening-round')}

            <div className="play-in-config-row">
              <div className="play-in-container">
                <h2>Opening Round</h2>
                <div className="bracket">
                  {Array.from({ length: OPENING_ROUND_GAMES }, (_, i) => i).map(matchupNum => (
                    <div key={matchupNum} className="matchup-pair">
                      {bracket['Play-in']?.filter(slot => slot.matchup === matchupNum).map((slot, index) => {
                        const slotIndex = bracket['Play-in'].indexOf(slot);
                        return (
                          <div
                            key={index}
                            className={`matchup round-${slot.round} matchup-${slot.matchup} ${slot.team ? 'filled' : ''}`}
                            draggable={!!slot.team}
                            tabIndex={0}
                            role="button"
                            aria-label={`Opening Round, ${slot.seed} seed, ${slot.team || 'empty'}`}
                            onDragStart={(e) => handleBracketDragStart(e, 'Play-in', slotIndex)}
                            onDragOver={handleDragOver}
                            onDrop={(e) => handleBracketDrop(e, 'Play-in', slotIndex)}
                            onClick={() => placeTeam('Play-in', slotIndex)}
                            onKeyDown={(e) => handleSlotKeyDown(e, () => placeTeam('Play-in', slotIndex))}
                          >
                            <span className="matchup-text">
                              {slot.team ? <><TeamBadge team={slot.team} />{slot.seed} {slot.team}</> : `${slot.seed} (Click to place)`}
                            </span>
                            {slot.team && (
                              <div className="seed-slot-buttons">
                                <button onClick={(e) => { e.stopPropagation(); removeTeam('Play-in', slotIndex); }} className="remove-button">Remove</button>
                                <button
                                  onClick={(e) => { e.stopPropagation(); handleBracketSwapClick('Play-in', slotIndex); }}
                                  className={`swap-button ${bracketSwapMode && bracketSwapSlot?.region === 'Play-in' && bracketSwapSlot?.index === slotIndex ? 'swap-active' : ''}`}
                                >
                                  Swap
                                </button>
                              </div>
                            )}
                          </div>
                        );
                      }) || null}
                    </div>
                  ))}
                </div>
              </div>

              <div className="config-container">
                <h2>Opening Round Configuration</h2>
                <p className="config-caption">
                  <span className="config-aq-tag">AQ</span> games have a seed fixed by NCAA rule (the dashed
                  4 are fully fixed; the rest can move regions). Unmarked games are at-large and fully adjustable.
                </p>
                <div className="config-list">
                  {playInConfig.map((config, i) => (
                    <div key={i} className={`config-item ${config.locked ? 'config-locked' : ''}`}>
                      <div className="config-label">{i + 1}</div>
                      {config.locked || config.seedLocked ? (
                        <span
                          className="config-seed-fixed"
                          title={config.locked ? 'Fixed by NCAA rule (seed and region)' : 'Fixed at seed 15 by NCAA rule - region is adjustable'}
                        >
                          {config.seed}
                        </span>
                      ) : (
                        <select
                          value={config.seed}
                          onChange={(e) => handleConfigChange(i, 'seed', e.target.value)}
                          className="config-select"
                        >
                          {atLargePossibleSeeds.map(s => (
                            <option key={s} value={s}>{s}</option>
                          ))}
                        </select>
                      )}
                      <div className="config-arrow">→</div>
                      {config.locked ? (
                        <div className="config-region">{config.region}</div>
                      ) : (
                        <select
                          value={config.region}
                          onChange={(e) => handleConfigChange(i, 'region', e.target.value)}
                          className="config-select config-region-select"
                        >
                          {regions.map(r => (
                            <option key={r} value={r}>{r}</option>
                          ))}
                        </select>
                      )}
                      {(config.locked || config.seedLocked) && <span className="config-aq-tag">AQ</span>}
                    </div>
                  ))}
                </div>
              </div>
            </div>

            {renderTeamSelector('regions')}

            <p className="region-order-instructions">Drag and drop to adjust region locations</p>
            <div className="regions-row">
              {regionOrder.map(regionName => (
                <div key={regionName} className={`region-container region-${regionName.toLowerCase()}`} draggable onDragStart={e => handleRegionDragStart(e, regionName)} onDragOver={handleDragOver} onDrop={e => handleRegionDrop(e, regionName)}>
                  <h2>{regionName}</h2>
                  <div className="bracket">
                    {[0,1,2,3,4,5,6,7].map(m => (
                      <div key={m} className="matchup-pair">
                        {bracket[regionName]?.filter(s => s.matchup === m).map((slot, i) => {
                          const slotIndex = bracket[regionName].indexOf(slot);
                          return (
                            <div
                            key={i}
                            className={`matchup ${slot.team ? 'filled' : ''}`}
                            draggable={!!slot.team}
                            tabIndex={0}
                            role="button"
                            aria-label={`${regionName}, ${slot.seed} seed, ${slot.team ? slot.team : (slot.playInLinked ? 'pending Opening Round' : 'empty')}`}
                            onDragStart={(e) => handleBracketDragStart(e, regionName, slotIndex)}
                            onDragOver={handleDragOver}
                            onDrop={(e) => handleBracketDrop(e, regionName, slotIndex)}
                            onClick={() => { if (!bracketSwapMode) placeTeam(regionName, slotIndex); }}
                            onKeyDown={(e) => handleSlotKeyDown(e, () => {
                              if (!bracketSwapMode) placeTeam(regionName, slotIndex);
                            })}
                          >
                            <span className="matchup-text">
                              {slot.team && !slot.playInLinked ? (
                                <><TeamBadge team={slot.team} />{slot.seed} {slot.team}</>
                              ) : (
                                `${slot.seed} ${slot.team ? slot.team : (slot.playInLinked ? 'Opening Round Winner' : '(Click to place)')}`
                              )}
                            </span>
                              {slot.team && !slot.playInLinked && (
                                <div className="seed-slot-buttons">
                                  <button onClick={e => { e.stopPropagation(); removeTeam(regionName, slotIndex); }} className="remove-button">Remove</button>
                                  <button
                                    onClick={e => { e.stopPropagation(); handleBracketSwapClick(regionName, slotIndex); }}
                                    className={`swap-button ${bracketSwapMode && bracketSwapSlot?.region === regionName && bracketSwapSlot?.index === slotIndex ? 'swap-active' : ''}`}
                                  >
                                    Swap
                                  </button>
                                </div>
                              )}
                            </div>
                          );
                        }) || null}
                      </div>
                    ))}
                  </div>
                </div>
              ))}
            </div>

            {renderTeamSelector('regions-bubble-watch')}
            {renderBubbleWatch()}
          </>
        )}

        {activeTab === 'conferences' && (
          <div className="export-header">
            <div className="logo-title">
              <h1>{customTitle || 'My Bracket'} — Conference Breakdown</h1>
              <img src={logo} alt="MyBracket.online" className="export-logo" />
            </div>
          </div>
        )}

        {activeTab === 'conferences' && (
          <div className="conferences-tab">
            <h2>Conference Breakdown</h2>
            <p className="conferences-caption">
              How many teams from each conference are currently in your bracket, sorted by bid count.
              Seed numbers are shown next to each team; <span className="conference-card-seed">*</span> means
              they're playing an Opening Round game for that seed.
              {getMissingConferences().length > 0 && (
                <> {getMissingConferences().length} conference{getMissingConferences().length === 1 ? '' : 's'} still {getMissingConferences().length === 1 ? 'has' : 'have'} zero teams placed.</>
              )}
            </p>
            <div className="conferences-grid">
              {getConferenceBreakdown().map(({ conference, teams }) => (
                <div key={conference} className={`conference-card ${teams.length === 0 ? 'empty' : ''}`}>
                  <div className="conference-card-header">
                    <span className="conference-card-name">{conference}</span>
                    <span className="conference-card-count">{teams.length}</span>
                  </div>
                  {teams.length > 0 && (
                    <div className="conference-card-teams">
                      {teams.map(t => (
                        <span key={t.name} className="conference-card-team">
                          <TeamBadge team={t.name} />
                          <span className="conference-card-team-name">{t.name}</span>
                          <span
                            className="conference-card-seed"
                            title={t.openingRound ? `Playing an Opening Round game for the ${t.seed} seed` : `${t.seed} seed`}
                          >
                            {t.seed}{t.openingRound ? '*' : ''}
                          </span>
                        </span>
                      ))}
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        )}

        {activeTab === 'teamMetrics' && (
          <div className="metrics-tab">
            <h2>Team Metrics</h2>
            <p className="metrics-intro">
              When the Selection Committee evaluates a team, they work from a "team sheet," a single
              page summarizing that team's resume. Here's what's on it, and where to find each piece
              yourself.
            </p>

            <div className="metrics-section">
              <h3>The NET</h3>
              <p>
                The NCAA Evaluation Tool is the committee's primary sorting tool, replacing the RPI in
                2018. It isn't a ranking the committee follows directly. It's the mechanism that sorts
                every team's wins and losses into quadrants based on opponent strength and where the
                game was played.
              </p>
            </div>

            <div className="metrics-section">
              <h3>Quadrants</h3>
              <p>
                Every game gets classified by the opponent's NET rank <em>and</em> the venue, which is
                why a road win counts for more than the same win at home. For men's basketball:
              </p>
              <div className="metrics-quad-grid">
                <div className="metrics-quad">
                  <span className="metrics-quad-label">Quadrant 1</span>
                  Home 1-30 · Neutral 1-50 · Away 1-75
                </div>
                <div className="metrics-quad">
                  <span className="metrics-quad-label">Quadrant 2</span>
                  Home 31-75 · Neutral 51-100 · Away 76-135
                </div>
                <div className="metrics-quad">
                  <span className="metrics-quad-label">Quadrant 3</span>
                  Home 76-160 · Neutral 101-200 · Away 136-240
                </div>
                <div className="metrics-quad">
                  <span className="metrics-quad-label">Quadrant 4</span>
                  Home 161+ · Neutral 201+ · Away 241+
                </div>
              </div>
              <p className="metrics-note">
                Q1 wins are what build an at-large case. Q3 and Q4 losses are what sink one.
              </p>
            </div>

            <div className="metrics-section">
              <h3>Results-Based Metrics</h3>
              <p>
                These ask "how good is this team's <em>resume</em>?" They reward what you've actually
                accomplished, not how good you look doing it.
              </p>
              <ul className="metrics-list">
                <li>
                  <strong>KPI (Kevin Pauga Index)</strong>: grades every individual game on its own
                  merit, weighing opponent, location, and score. Strictly this season's results.
                </li>
                <li>
                  <strong>SOR (Strength of Record)</strong>: the probability that a typical No. 25 team
                  would match your record against your exact schedule. Factors in travel, rest, and
                  altitude.
                </li>
                <li>
                  <strong>WAB (Wins Above Bubble)</strong>: how many more games you've won than a
                  typical bubble team would have, given the same schedule.
                </li>
              </ul>
            </div>

            <div className="metrics-section">
              <h3>Predictive Metrics</h3>
              <p>
                These ask "how good is this team, really?" They're efficiency-based, and generally less
                forgiving of a weak schedule padded with blowouts.
              </p>
              <ul className="metrics-list">
                <li>
                  <strong>KenPom</strong>: adjusted offensive and defensive efficiency per 100
                  possessions. The longest-standing and most widely cited of the three.
                </li>
                <li>
                  <strong>BPI (Basketball Power Index)</strong>: ESPN's model, expressed as expected
                  point margin per 70 possessions against an average D-I team on a neutral floor.
                </li>
                <li>
                  <strong>T-Rank (Torvik)</strong>: similar efficiency approach, but discounts garbage
                  time and weights recent games more heavily. Added to the committee's criteria in
                  2024-25.
                </li>
              </ul>
            </div>

            <div className="metrics-section">
              <h3>Everything Else</h3>
              <p>
                The metrics don't decide it alone. The committee also weighs strength of schedule
                (overall and non-conference), road and neutral-site records, head-to-head results,
                common opponents, and player availability. A team that lost its best player in
                February isn't the same team the metrics saw in December.
              </p>
            </div>

            <div className="metrics-section">
              <h3>Where To Find Them</h3>
              <ul className="metrics-links">
                <li>
                  <a href="https://www.ncaa.com/rankings/basketball-men/d1/ncaa-mens-basketball-net-rankings" target="_blank" rel="noopener noreferrer">NCAA.com: Official NET Rankings</a>
                  <span>The source of record, updated daily in season.</span>
                </li>
                <li>
                  <a href="https://www.warrennolan.com/basketball/2026/net-nitty" target="_blank" rel="noopener noreferrer">WarrenNolan.com: NET Nitty Gritty</a>
                  <span>Quadrant records, SOS, and full team sheets in one place.</span>
                </li>
                <li>
                  <a href="https://kenpom.com/" target="_blank" rel="noopener noreferrer">KenPom.com</a>
                  <span>Adjusted efficiency ratings. Subscription required for full access.</span>
                </li>
                <li>
                  <a href="https://barttorvik.com/" target="_blank" rel="noopener noreferrer">BartTorvik.com: T-Rank</a>
                  <span>Efficiency ratings plus a deep set of custom query tools.</span>
                </li>
                <li>
                  <a href="https://www.espn.com/mens-college-basketball/bpi" target="_blank" rel="noopener noreferrer">ESPN: BPI &amp; Strength of Record</a>
                  <span>Both of ESPN's committee-referenced metrics.</span>
                </li>
                <li>
                  <a href="https://www.kpisports.net/" target="_blank" rel="noopener noreferrer">KPISports.net: Kevin Pauga Index</a>
                  <span>The KPI rankings, direct from their creator.</span>
                </li>
                <li>
                  <a href="https://bracketologists.com/" target="_blank" rel="noopener noreferrer">Bracketologists.com</a>
                  <span>Every metric side by side, with resume comparison tools. Not affiliated with this site.</span>
                </li>
              </ul>
            </div>

            <p className="metrics-disclaimer">
              MyBracket.online isn't affiliated with any of the sites above, and doesn't republish their
              data. These are links so you can go straight to the source.
            </p>
          </div>
        )}

        <div className="export-footer">
          Created with <strong>mybracket.online</strong>
        </div>
      </div>

      <p className="site-footer">
        &copy; {new Date().getFullYear()} MyBracket.online. All rights reserved.
        {' '}·{' '}
        <a href="/about.html" className="site-footer-link">About</a>
        {' '}·{' '}
        <a href="/privacy.html" className="site-footer-link">Privacy Policy</a>
        {' '}·{' '}
        <a href="/terms.html" className="site-footer-link">Terms of Service</a>
      </p>
    </div>
  );
}

// Catches unexpected render/runtime errors anywhere in the app and shows a
// recoverable message instead of a blank white screen. Must be a class
// component - React doesn't support error boundaries via hooks.
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error('MyBracket crashed:', error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="error-boundary">
          <div className="error-boundary-card">
            <h1>Something went wrong</h1>
            <p>
              Sorry about that — an unexpected error happened. Your bracket is likely still
              safe (it auto-saves locally as you work), so reloading should get you right
              back to where you were.
            </p>
            <button onClick={() => window.location.reload()} className="error-boundary-button">
              Reload Page
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

function AppWithErrorBoundary() {
  return (
    <>
      <ErrorBoundary>
        <App />
      </ErrorBoundary>
      <Analytics />
    </>
  );
}

export default AppWithErrorBoundary;